<template>
  <div class="report content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="row">
          <div class="col-12">
            <div class="content__box">
              <div class="content__box__body">
                <div class="reportsTopbar">
                  <div>
                    <p class="text-white txt--ss opacity--50">
                      {{ $t("REPORT") }}
                    </p>
                  </div>
                  <!-- DATE RANGE PICKER -->
                  <div class="dateSlider ml-5">
                    <span
                      class="txt-s opacity--50 cursor-pointer"
                      @click="getPreDateStart()"
                    >
                      <i class="fas fa-chevron-left"></i>
                    </span>
                    <!-- <span class="txt--primary txt--ss txt--semi-bold mx-2">April 22 - April 29, 2020</span> -->
                    <VueCtkDateTimePicker
                      class="date__range__input mx-2"
                      v-model="date"
                      :range="true"
                      format="YYYY-MM-DD"
                      formatted="MMM D, YYYY"
                      :auto-close="true"
                      :no-label="true"
                      :only-date="true"
                      :dark="true"
                      :no-button="true"
                      input-size="sm"
                      :noClearButton="true"
                      :error="false"
                      color="#f5a621"
                      @input="validateRange()"
                      :no-shortcuts="true"
                      :custom-shortcuts="rangeShortCut"
                      :max-date="maxDate"
                      :min-date="minDate"
                    ></VueCtkDateTimePicker>
                    <span
                      class="txt-s opacity--50 cursor-pointer"
                      @click="getNextDateStart()"
                    >
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </div>
                  <div class="filterReport mt-3 mt-sm-0 ml-0 ml-sm-5">
                    <p class="txt--ss opacity--25">Filter:</p>
                    <!-- PROPERTY DROPDOWN -->
                    <div
                      class="filter__dropdown ml-3"
                      @mouseover="showPermitByDropdown = false; showTimezoneDropdown = false; showByDropdown = true"
                      @click.stop="showByDropdown = true"
                    >
                      <p
                        class="
                          txt--ss
                          opacity--50
                          cursor-pointer
                          alignment-report
                        "
                      >
                        {{ $t("PROPERTY") }}
                      </p>
                      <span
                        v-if="selected_property_name"
                        class="ml-1 txt--primary txt--ss my-3 txt--semi-bold"
                        >{{ selected_property_name }}</span
                      >
                      <div
                        class="filter__items"
                        v-show="showByDropdown"
                        @mouseleave="showByDropdown = false"
                        v-click-outside="closeDropdown"
                      >
                        <div class>
                          <input
                            type="text"
                            placeholder="Find property"
                            aria-label="Search"
                            class="input__field"
                            v-model="searchProperty"
                            @keyup="getAllProperty"
                          />
                          <div class="px-3 mt-3">
                            <div class="top__filter">
                              <ul class="top__filter__ul">
                                <li>Property</li>
                              </ul>
                              <ul class="top__filter__ul">
                                <li class @click="clearPropertyFilter()">
                                  Clear {{ $t("Filter") }}
                                </li>
                                <!-- <li>None</li> -->
                              </ul>
                            </div>
                            <div
                              class="propertyFilters"
                              v-if="property_list.length > 0"
                            >
                              <p
                                class="
                                  txt--primary txt--ss
                                  my-3
                                  txt--semi-bold
                                  cursor-pointer
                                "
                                v-for="(p, index) in property_list"
                                :key="index"
                              >
                                <span
                                  class="cursor-pointer"
                                  @click="getAllReportsForSpace(p, null)"
                                >
                                  {{
                                    p.property_name != ""
                                      ? p.property_name
                                      : p.address.split(",")[0]
                                  }}
                                </span>
                              </p>
                            </div>
                            <div
                              class="
                                propertyFilters
                                d-flex
                                justify-content-center
                              "
                              v-else
                            >
                              <p
                                class="txt--primary txt--ss my-3 txt--semi-bold"
                              >
                                No Property Found
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- PERMIT DROPDOWN -->
                    <div
                      class="filter__dropdown ml-3"
                      @mouseover="showByDropdown = false; showTimezoneDropdown = false; showPermitByDropdown = true"
                      @click.stop="showPermitByDropdown = true"
                    >
                      <p
                        class="
                          txt--ss
                          opacity--50
                          cursor-pointer
                          alignment-report
                        "
                      >
                        {{ $t("Permit") }}
                      </p>
                      <span
                        v-if="selected_permit_name"
                        class="ml-1 txt--primary txt--ss my-3 txt--semi-bold"
                        >{{ selected_permit_name }}</span
                      >
                      <div
                        class="filter__items"
                        v-show="showPermitByDropdown"
                        @mouseleave="showPermitByDropdown = false"
                        v-click-outside="closeDropdown"
                      >
                        <div class>
                          <input
                            type="text"
                            placeholder="Find permit"
                            aria-label="Search"
                            class="input__field"
                            v-model="searchPermit"
                            @keyup="getPermits"
                          />
                          <div class="px-3 mt-3">
                            <div class="top__filter">
                              <ul class="top__filter__ul">
                                <li>Permit</li>
                              </ul>
                              <ul class="top__filter__ul">
                                <li class @click="clearPermitFilter()">
                                  Clear {{ $t("Filter") }}
                                </li>
                                <!-- <li>None</li> -->
                              </ul>
                            </div>
                            <div
                              class="propertyFilters"
                              v-if="permit_list.length > 0"
                            >
                              <p
                                class="
                                  txt--primary txt--ss
                                  my-3
                                  txt--semi-bold
                                  cursor-pointer
                                "
                                v-for="(p, index) in permit_list"
                                :key="index"
                              >
                                <span
                                  class="cursor-pointer"
                                  @click="getAllReportsForSpace(null, p)"
                                >
                                  {{ p.permit_name }}
                                </span>
                              </p>
                            </div>
                            <div
                              class="
                                propertyFilters
                                d-flex
                                justify-content-center
                              "
                              v-else
                            >
                              <p
                                class="txt--primary txt--ss my-3 txt--semi-bold"
                              >
                                No Permit Found
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Timezone Filter -->
                  <div class="filterReport mt-3 mt-sm-0 ml-0 ml-sm-5">
                    <p class="txt--ss opacity--25">Time zone:</p>
                    <div class="filter__dropdown ml-3" @mouseover="showByDropdown = false; showPermitByDropdown = false; showTimezoneDropdown = true"
                      @click.stop="showTimezoneDropdown = true">
                      <p class="txt--ss cursor-pointer alignment-report">
                        <span class="ml-1 txt--primary txt--ss my-3 txt--semi-bold">
                          {{selected_time_zone}}
                        </span>
                      </p>
                      <div class="filter__items" v-show="showTimezoneDropdown"
                        @mouseleave="showTimezoneDropdown = false"
                        v-click-outside="closeTimezoneDropdown">
                        <div>
                          <div class="px-3">
                            <div class="propertyFilters" v-if="time_zone_list.length > 0">
                              <p class="txt--primary txt--ss my-3 txt--semi-bold cursor-pointer" v-for="(time_zone, index) in time_zone_list" :key="index">
                                <span @click="setReportTimezone(time_zone)">
                                  {{time_zone}}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- EXPORT SECTION -->
                  <ul class="top__filter__ul exportReport mt-3 mt-sm-0 ml-0 text-right ml-sm-auto">
                    <div class="dropdown property__edit__dropdown mr-3" v-if="admin_access || commercial_user_id === '6165a634b7484e34902e6242' || commercial_user_id === '60b1846a0611b655395c4832'">
                      <p
                        v-show="!percentLoader"
                        class="
                          txt--ss
                          opacity--50
                          cursor-pointer
                          dropdown-toggle
                        "
                        data-toggle="dropdown"
                      >
                        {{ $t("CUSTOM_REPORTS") }}
                      </p>
                      <div v-show="percentLoader" class="reportSpinner"></div>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a v-if="commercial_user_id === '6165a634b7484e34902e6242'"
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="exportCustomReport('subdomain_registrations')">Registration Report</a>
                        <a v-if="commercial_user_id === '60b1846a0611b655395c4832'"
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="exportCustomReport('morning_parking_sessions', { requireDate: true })">Morning Parking Sessions</a>
                        <a v-if="commercial_user_id === '60b1846a0611b655395c4832'"
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="exportCustomReport('keck_permit_holders')">Parking Permit Holders</a>
                        <a v-if="commercial_user_id === '60b1846a0611b655395c4832'"
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="exportCustomReport('parking_permit_sessions', { requireDate: true, requireDateRangeType: true, requirePermitIds: true })">Parking Permit Sessions</a>
                        <a v-if="commercial_user_id === '60b1846a0611b655395c4832'"
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="exportCustomReport('parking_delinquencies', { requireDate: true, requireDateRangeType: true })">Parking Session Statistics</a>
                        <a v-if="commercial_user_id === '676057770924c610a55d3116'"
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="exportCustomReport('validations_by_department', { requireDate: true, requireDateRangeType: true })">Validations By Department</a>
                      </div>
                    </div>
                    <div class="dropdown property__edit__dropdown">
                      <p
                        v-show="!percentLoader"
                        class="
                          txt--ss
                          opacity--50
                          cursor-pointer
                          dropdown-toggle
                        "
                        data-toggle="dropdown"
                      >
                        {{ $t("EXPORT") }}
                      </p>
                      <div v-show="percentLoader" class="reportSpinner"></div>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <!-- <router-link class="dropdown-item mt-0 my-2" to="/report-pdf">Download PDF</router-link> -->
                        <!-- <a
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="getPageData()"
                          >Export as PDF</a
                        > -->
                        <a
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="getCSV()"
                          >Export as XLSX</a
                        >
                        <a
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="openModal('download-export-reports')"
                          >Download Exported File</a
                        >
                        <!-- <a
                          class="dropdown-item mt-0 my-2"
                          href="javascript:void(0);"
                          @click="getZip()"
                          >Export as CSV</a
                        > -->
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-8 mt-4">
            <!-- AVERAGE REPORT -->
            <div class="content__box">
              <div class="content__box__body">
                <div class="row">
                  <!-- TRANSIENT CUSTOMER COUNT -->
                  <div
                    class="
                      col-sm-6 col-md-4 col-xl
                      mt-3 mt-md-0
                      customers-records
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <p class="txt--ss opacity--50">{{ $t("TC") }}</p>
                      <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.transient_customer_count"></i></p>
                    </div>
                    <div v-if="transient_loader == 0">
                      <p class="txt--fslg pt-2">
                        {{ session_reports.transient_customer }}
                      </p>
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          session_reports.transient_customer_inc
                            ? 'txt--green'
                            : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            session_reports.transient_customer_inc
                              ? 'txt--green'
                              : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{ session_reports.transient_customer_inc_value }}%
                      </p>
                    </div>
                    <div v-else-if="transient_loader == 2">
                      <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                      <button 
                        @click="getTransientReport" 
                         
                        type="button" 
                        class="button button--primary button--sm mr-3 mt-2"
                      >
                        <span >Reload</span>
                      </button>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- PERMIT CUSTOMER COUNT -->
                  <div
                    class="
                      col-sm-6 col-md-4 col-xl
                      mt-3 mt-md-0
                      customers-records
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <p class="txt--ss opacity--50">{{ $t("MC") }}</p>
                      <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.permit_customer_count"></i></p>
                    </div>
                    <div v-if="permit_customer_loader == 0">
                      <p class="txt--fslg pt-2">
                        {{ session_reports.monthly_customer }}
                      </p>
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          session_reports.monthly_customer_inc
                            ? 'txt--green'
                            : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            session_reports.monthly_customer_inc
                              ? 'txt--green'
                              : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{ session_reports.monthly_customer_inc_value }}%
                      </p>
                    </div>
                    <div v-else-if="permit_customer_loader == 2">
                      <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                      <button 
                        @click="getPermitCustomer" 
                         
                        type="button" 
                        class="button button--primary button--sm mr-3 mt-2"
                      >
                        <span >Reload</span>
                      </button>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ANONYMOUS CUSTOMER COUNT -->
                  <div
                    class="
                      col-sm-6 col-md-4 col-xl
                      mt-3 mt-xl-0
                      customers-records
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <p class="txt--ss opacity--50">{{ $t("AC") }}</p>
                      <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.anonymous_customer_count"></i></p>
                    </div>
                    <div v-if="anonymous_customer_loader == 0">
                      <p class="txt--fslg pt-2">
                        {{ session_reports.anonymous_customer }}
                      </p>
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          session_reports.anonymous_customer_inc
                            ? 'txt--green'
                            : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            session_reports.anonymous_customer_inc
                              ? 'txt--green'
                              : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{ session_reports.anonymous_customer_inc_value }}%
                      </p>
                    </div>                        
                    <div v-else-if="anonymous_customer_loader == 2">
                      <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                      <button 
                        @click="getAnonymousCustomer" 
                         
                        type="button" 
                        class="button button--primary button--sm mr-3 mt-2"
                      >
                        <span >Reload</span>
                      </button>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- AVERAGE SESSION DURATION -->
                  <!--{{--<div
                    class="
                      col-sm-6 col-md-4 col-xl
                      mt-3 mt-md-0
                      customers-records
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <p class="txt--ss opacity--50">{{ $t("AVGSD") }}</p>
                      <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.avg_session_duration"></i></p>
                    </div>
                    <div v-if="avg_session_loader == 0">
                      <p class="txt--fslg pt-2">
                        {{ session_reports.avg_session_duration }}
                      </p>
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          session_reports.avg_session_duration_inc
                            ? 'txt--green'
                            : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            session_reports.avg_session_duration_inc
                              ? 'txt--green'
                              : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{
                          session_reports.avg_session_duration_inc_value
                        }}%
                      </p>
                    </div>
                    <div v-else-if="avg_session_loader == 2">
                      <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                      <button 
                        @click="getAvgSessionReport" 
                         
                        type="button" 
                        class="button button--primary button--sm mr-3 mt-2"
                      >
                        <span >Reload</span>
                      </button>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>--}}-->
                  <!-- AVERAGE SESSION PRICE -->
                  <!--{{--<div
                    class="
                      col-sm-6 col-md-4 col-xl
                      mt-3 mt-xl-0
                      customers-records
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <p class="txt--ss opacity--50">{{ $t("AVGSP") }}</p>
                      <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.avg_session_price"></i></p>
                    </div>
                    <div v-if="avg_session_price_loader == 0">
                      <p class="txt--fslg pt-2">
                        ${{ session_reports.avg_session_price }}
                      </p>
                      <p
                        :class="[
                          'transient-customers-records txt--ss mt-3',
                          session_reports.avg_session_price_inc
                            ? 'txt--green'
                            : 'txt--red',
                        ]"
                      >
                        <span
                          :class="[
                            session_reports.avg_session_price_inc
                              ? 'txt--green'
                              : 'txt--red',
                            'rounded-circle',
                          ]"
                        ></span>
                        {{ session_reports.avg_session_price_inc_value }}%
                      </p>
                    </div>
                    <div v-else-if="avg_session_price_loader == 2">
                      <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                      <button 
                        @click="getAvgSessionPrice" 
                         
                        type="button" 
                        class="button button--primary button--sm mr-3 mt-2"
                      >
                        <span >Reload</span>
                      </button>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>--}}-->
                </div>
              </div>
            </div>

            <!-- ALL PROPERTY REPORT -->
            <div class="content__box mt-4">
              <div class="content__box__header">
                <p class="text-white txt--ss opacity--50">{{ $t("PROPES") }}</p>
              </div>
              <div class="content__divider"></div>
              <div class="reports__propeties">
                <div class="reports__stats-header">
                  <div class="row">
                    <div class="col-2">
                      <p class="txt--primary txt--xs txt--semi-bold">
                        {{ $t("PROPERTY") }}
                        <span class="pl-1">
                          <!-- <i class="fas fa-angle-down"></i> -->
                        </span>
                      </p>
                    </div>
                    <div class="col-1">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("SESSION") }}
                      </p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("TC") }}
                      </p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("MC") }}
                      </p>
                    </div>
                    <div class="col-2">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("AC") }}
                      </p>
                    </div>
                    <div class="col-1">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("VC") }}
                      </p>
                    </div>
                    <div class="col-1">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("OCCUP") }}
                      </p>
                    </div>
                    <div class="col-1">
                      <p class="txt--xs txt--semi-bold opacity--50">
                        {{ $t("EARN") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="property_details_loader">
                  <div class="d-flex justify-content-center">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div
                  class="reports__stats-body"
                  v-else-if="property_details_report.length"
                >
                  <div
                    class="reports__item"
                    :class="{
                      'sticky-open':
                        over_view_report_type === 'sessions' + index ||
                        over_view_report_type === 'transient' + index ||
                        over_view_report_type === 'permit' + index ||
                        over_view_report_type === 'anonymous' + index ||
                        over_view_report_type === 'validation' + index ||
                        over_view_report_type === 'occupancy' + index ||
                        over_view_report_type === 'earnings' + index,
                    }"
                    v-for="(report, index) in property_details_report"
                    :key="index"
                  >
                    <div class="row reports__padding">
                      <div class="col-2">
                        <p class="txt--primary property__header__text">
                          {{ report.space_name }}
                        </p>
                      </div>
                      <div class="col-1" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active: over_view_report_type === 'sessions' + index,
                          }"
                          @click="sessionReport(report.space_id,index)"
                        >
                          {{ report.session_count+'   ('+report.session_count_within_interval+')' }}
                        </p>
                      </div>
                      <div class="col-2" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active:
                              over_view_report_type === 'transient' + index,
                          }"
                          @click="transientReport(report.space_id, index)"
                        >
                          {{ report.transient_customer_count }}
                        </p>
                      </div>
                      <div class="col-2" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active:
                              over_view_report_type === 'permit' + index,
                          }"
                          @click="permitReport(report.space_id, index)"
                        >
                          {{ report.permit_customer_count }}
                        </p>
                      </div>
                      <div class="col-2" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active:
                              over_view_report_type === 'anonymous' + index,
                          }"
                          @click="anonymousReport(report.space_id, index)"
                        >
                          {{ report.anonymous_customer_count }}
                        </p>
                      </div>
                      <div class="col-1" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active:
                              over_view_report_type === 'validation' + index,
                          }"
                          @click="validationReport(report.space_id, index)"
                        >
                          {{ report.validation_count }}
                        </p>
                      </div>
                      <div class="col-1" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active: over_view_report_type === 'occupancy' + index,
                          }"
                          @click="occupancyReport(report.space_id, index)"
                        >
                          {{ (report.occupancy).toFixed(0)}}%
                        </p>
                      </div>
                      <div class="col-1" v-if="!report.loading">
                        <p
                          class="property__header__text cursor-pointer"
                          :class="{
                            active: over_view_report_type === 'earnings' + index,
                          }"
                          @click="earningReport(report.space_id, index)"
                        >
                          ${{ report.earnings.toFixed(2) }}
                        </p>
                      </div>
                      <div class="col-10" v-if="report.loading">
                        <div class="d-flex justify-content-center">
                          <p class="txt--ss opacity--50">Loading...</p>
                        </div>
                      </div>
                    </div>
                    <!-- SESSIONS -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'sessions' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 report-inner-header pb-1">
                          <div class="col-2">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              Start At
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'book_start_date') || field_name != 'book_start_date'" 
                                @click="setOrderBy('book_start_date','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'book_start_date'" 
                                @click="setOrderBy('book_start_date','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("Session_Type") }}
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'booking_type') || field_name != 'booking_type'"
                                @click="setOrderBy('booking_type','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'booking_type'" 
                                @click="setOrderBy('booking_type','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("Duration") }}
                              <!-- <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'stay_duration') || field_name != 'stay_duration'" 
                                @click="setOrderBy('stay_duration','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'stay_duration'" 
                                @click="setOrderBy('stay_duration','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span> -->
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("Ended_At") }}
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'book_end_date') || field_name != 'book_end_date'" 
                                @click="setOrderBy('book_end_date','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'book_end_date'" 
                                @click="setOrderBy('book_end_date','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("Amount") }}
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'subtotal') || field_name != 'subtotal'" 
                                @click="setOrderBy('subtotal','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'subtotal'" 
                                @click="setOrderBy('subtotal','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("Vehicle") }}
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'license_id') || field_name != 'license_id'" 
                                @click="setOrderBy('license_id','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'license_id'" 
                                @click="setOrderBy('license_id','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <!-- <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("Deleted_Status") }}
                              <!- <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'deleted_at') || field_name != 'deleted_at'" 
                                @click="setOrderBy('deleted_at','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'deleted_at'" 
                                @click="setOrderBy('deleted_at','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span> ->
                            </p>
                          </div>
                          <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("MERGED_AT") }}
                            </p>
                          </div> -->
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="reports__details--body"
                          v-else-if="property_details_inner_report.length"
                        >
                          <div
                            class="row pt-3"
                            v-for="(
                              inner_report, index
                            ) in property_details_inner_report"
                            :key="index"
                            @click="openSessionDetails(inner_report.booking_id,inner_report.delete_status)"
                          >
                            <div class="col-2 cursor-pointer">
                              <p class="txt--primary txt--semi-bold txt--xs">
                              <!-- :class="[ inner_report.delete_status ? 'txt--red' : '' ]"> -->
                                  {{ formatDateWithTimezone(inner_report.book_start_date) }}
                                  <!-- <span v-if="inner_report.book_end_date != '' && inner_report.exit_image_available == false">(No Exit Image)</span> -->
                              </p>
                            </div>
                            <div class="col-2 cursor-pointer">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ getSessionType(inner_report) }}
                              </p>
                            </div>
                            <div class="col-2 cursor-pointer">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.stay_duration }}
                              </p>
                            </div>
                            <div class="col-2 cursor-pointer">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{
                                  inner_report.continued == 0
                                    ? formatDateWithTimezone(inner_report.book_end_date)
                                    : "Continued"
                                }}
                                <span v-if="inner_report.book_end_date != '' && inner_report.exit_image_available == false">*</span>
                              </p>
                            </div>
                            <div class="col-2 cursor-pointer">
                              <p
                                class="txt--xs txt--semi-bold opacity--50"
                                v-if="inner_report.session_type == 'transient'"
                              >
                                ${{ inner_report.subtotal.toFixed(2) }}
                              </p>
                              <p
                                class="txt--xs txt--semi-bold opacity--50"
                                v-else-if="
                                  inner_report.session_type == 'monthly'
                                "
                              >
                                $0.00
                              </p>
                              <p
                                class="txt--xs txt--semi-bold opacity--50"
                                v-else
                              >
                                $0.00 ({{
                                  inner_report.estimated_earning!=''? 'Estimated: $'+inner_report.estimated_earning.toFixed(2) : 'Estimated: N/A' 
                                }})
                              </p>
                            </div>
                            <div class="col-2 cursor-pointer">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.license }}
                                {{
                                  inner_report.state != ""
                                    ? "(" + inner_report.state + ")"
                                    : ""
                                }}
                              </p>
                            </div>
                            <!-- <div class="col-1 cursor-pointer">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{
                                  inner_report.delete_status==true? formatDateWithTimezone(inner_report.deleted_at) :'-'
                                }}
                              </p>
                            </div>
                            <div class="col-1 cursor-pointer">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{
                                  inner_report.session_merged_at && inner_report.session_merged_at!='' ? formatDateWithTimezone(inner_report.session_merged_at) : '-'
                                }}
                              </p>
                            </div> -->
                          </div>
                          <infinite-loading
                            @infinite="getSessionsPaginationWise"
                            :distance="10"
                            v-if="pagination.load_more==1"
                          >
                            <div slot="spinner">
                              <div class="d-flex justify-content-center mt-4">
                                <div class="lds-ring">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>
                            </div>
                            <div slot="no-more"></div>
                            <div slot="no-results">No data found</div>
                          </infinite-loading>
                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END SESSIONS -->

                    <!-- TRANSIENT CUSTOMER -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'transient' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 pb-1 report-inner-header">
                          <div class="col-4">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              First Name
                              <span class="pl-1">
                                <!-- <i class="fas fa-angle-down"></i> -->
                              </span>
                            </p>
                          </div>
                          <div class="col-4">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Last Name
                            </p>
                          </div>
                          <div class="col-4">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Vehicle
                            </p>
                          </div>
                          <!-- <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              State
                            </p>
                          </div> -->
                          <!-- <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Sessions</p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">Avg. Session Duration</p>
                          </div>
                          <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">Amount</p>
                          </div> -->
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="reports__details--body"
                          v-else-if="property_details_inner_report.length"
                        >
                          <div
                            class="row pt-3"
                            v-for="(
                              inner_report, index
                            ) in property_details_inner_report"
                            :key="index"
                          >
                            <div class="col-4">
                              <p class="txt--primary txt--xs txt--semi-bold">
                                {{ inner_report.first_name!='' ? inner_report.first_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-4">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.last_name!=''? inner_report.last_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-4">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.license_id }}
                                {{
                                  inner_report.state != ""
                                    ? " (" + inner_report.state + ")"
                                    : ""
                                }}
                              </p>
                            </div>
                            <!-- <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{
                                  inner_report.state != ""
                                    ? inner_report.state
                                    : ""
                                }}
                              </p>
                            </div> -->
                            <!-- <div class="col-2">
                              <p
                                class="txt--xs txt--semi-bold opacity--50"
                              >{{inner_report.duration_in_word}}</p>
                            </div>
                            <div class="col-2">
                              <p
                                class="txt--xs txt--semi-bold opacity--50"
                              >{{inner_report.average_duration}}</p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">${{inner_report.amount}}</p>
                            </div> -->
                          </div>
                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END TRANSIENT CUSTOMER -->

                    <!-- PERMIT CUSTOMER -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'permit' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 report-inner-header pb-1">
                          <div class="col">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              First Name
                              <span class="pl-1">
                                <!-- <i class="fas fa-angle-down"></i> -->
                              </span>
                            </p>
                          </div>
                          <div class="col">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Last Name
                            </p>
                          </div>
                          <div class="col">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Vehicle
                            </p>
                          </div>
                         <!--  <div class="col">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Type
                            </p>
                          </div>
                          <div class="col">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Sessions
                            </p>
                          </div> -->
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="reports__details--body"
                          v-else-if="property_details_inner_report.length"
                        >
                          <div
                            class="row pt-3"
                            v-for="(
                              inner_report, index
                            ) in property_details_inner_report"
                            :key="index"
                          >
                            <div class="col">
                              <p class="txt--primary txt--xs txt--semi-bold">
                                {{ inner_report.first_name!=''? inner_report.first_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.last_name!=''? inner_report.last_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.license_id
                                }}{{
                                  inner_report.state != ""
                                    ? " (" + inner_report.state + ")"
                                    : ""
                                }}
                              </p>
                            </div>
                           <!--  <div class="col d-none">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                Monthly
                              </p>
                            </div>
                            <div class="col d-none">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                34
                              </p>
                            </div> -->
                          </div>
                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END MONTHLY CUSTOMER -->

                    <!-- ANONYMOUS CUSTOMER -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'anonymous' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 report-inner-header pb-2">
                          <div class="col-4">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              First Name
                              <span class="pl-1">
                               
                              </span>
                            </p>
                          </div>
                          <div class="col-4">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Last Name
                            </p>
                          </div>
                          <div class="col-4">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Vehicle
                            </p>
                          </div>
                          
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="reports__details--body"
                          v-else-if="property_details_inner_report.length"
                        >
                          <div
                            class="row pt-3"
                            v-for="(
                              inner_report, index
                            ) in property_details_inner_report"
                            :key="index"
                          >
                            <div class="col-4">
                              <p class="txt--primary txt--xs txt--semi-bold">
                                {{ inner_report.first_name!=''? inner_report.first_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-4">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.last_name!=''? inner_report.last_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-4">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.license_id
                                }}{{
                                  inner_report.state != ""
                                    ? " (" + inner_report.state + ")"
                                    : ""
                                }}
                              </p>
                            </div>
                          
                          </div>
                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END ANONYMOUS CUSTOMER -->

                    <!-- VALIDATIONS -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'validation' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 report-inner-header pb-2">
                          <div class="col-1">
                          <p class="txt--primary txt--xs txt--semi-bold">
                             Date
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="(order_by == 'DESC' && field_name == 'validation_date') || field_name != 'validation_date'" 
                                @click="setValidationOrderBy('validation_date','ASC')"
                              >
                                <i class="fas fa-angle-up"></i>
                              </span>
                              <span 
                                class="pl-1 cursor-pointer" 
                                v-if="order_by == 'ASC' && field_name == 'validation_date'" 
                                @click="setValidationOrderBy('validation_date','DESC')"
                              >
                                <i class="fas fa-angle-down"></i>
                              </span>
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Validation Name
                            </p>
                          </div>
                          <!-- <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Validation #
                            </p>
                          </div> -->
                          <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Department
                            </p>
                          </div>
                          <div class="col-1">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Vehicle
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Validator First Name
                            </p>
                          </div>
                          <div class="col-2">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              Validator Last Name
                            </p>
                          </div>
                         
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                       
                        <div
                          class="reports__details--body"
                          v-else-if="property_details_inner_report.length"
                        >
                          <div
                            class="row pt-3"
                            v-for="(
                              inner_report, index
                            ) in property_details_inner_report"
                            :key="index"
                          >
                            <div class="col-1">
                              <p class="txt--primary txt--xs txt--semi-bold">
                                {{ inner_report.validation_date!=''? formatDateWithTimezone(inner_report.validation_date): 'N/A' }}
                              </p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                {{ inner_report.validation_name!=''? inner_report.validation_name: 'N/A' }}
                              </p>
                            </div>
                            <!-- <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                 {{ inner_report.validation_no!=''? inner_report.validation_no: 'N/A' }}
                              </p>
                            </div> -->
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                 {{ inner_report.validation_department!=''? inner_report.validation_department: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-1">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                 {{ inner_report.validation_vehicle_no!=''? inner_report.validation_vehicle_no: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                 {{ inner_report.validation_validator_first_name!=''? inner_report.validation_validator_first_name: 'N/A' }}
                              </p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs txt--semi-bold opacity--50">
                                 {{ inner_report.validation_validator_last_name!=''? inner_report.validation_validator_last_name: 'N/A' }}
                              </p>
                            </div>
                 
                          </div>

                          <infinite-loading
                            @infinite="getValidationReportPageWise"
                            :distance="10"
                            v-if="pagination.load_more==1"
                          >
                            <div slot="spinner">
                              <div class="d-flex justify-content-center mt-4">
                                <div class="lds-ring">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>
                            </div>
                            <div slot="no-more"></div>
                            <div slot="no-results">No data found</div>
                          </infinite-loading>

                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END VALIDATIONS -->

                    <!-- OCCUPANCY -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'occupancy' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 report-inner-header pb-2">
                          <div class="col-4">
                            <p class="txt--primary txt--xs txt--semi-bold">
                              Date
                              <span class="pl-1">
                                <!-- <i class="fas fa-angle-down"></i> -->
                              </span>
                            </p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("OCCUP") }}
                            </p>
                          </div>
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="reports__details--body"
                          v-else-if="property_details_inner_report.length"
                        >
                          <div
                            v-for="(
                              inner_report, index
                            ) in property_details_inner_report"
                            :key="index"
                          >
                            <div class="row pt-3">
                              <div class="col-4">
                                <p class="txt--primary txt--xs txt--semi-bold">
                                  {{ inner_report.date }}
                                </p>
                              </div>
                              <div class="col-2">
                                <p
                                  :class="[
                                    'txt--xs txt--semi-bold txt--off-white'
                                  ]"
                                >
                                  {{ (inner_report.occupancy * 100).toFixed(2) }}%
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END OCCUPANCY -->

                    <!-- EARNINGS -->
                    <div
                      class="reports__item__content"
                      v-if="over_view_report_type === 'earnings' + index"
                    >
                      <div class="content__divider"></div>
                      <div
                        class="reports__details"
                        :class="{ 'h-auto': selected_property_name }"
                      >
                        <div class="row pt-2 report-inner-header pb-2">
                          <div class="col-4">
                            <p class="txt--xs opacity--50 txt--semi-bold">
                              {{ $t("Type") }}
                            </p>
                          </div>
                          <div class="col-3">
                            <p class="txt--xs txt--semi-bold opacity--50">
                              {{ $t("EARN") }}
                            </p>
                          </div>
                        </div>
                        <div v-if="property_details_inner_loader">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div class="reports__details--body" v-else>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--xs opacity--50">{{ $t("TC") }}</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs opacity--50">
                                ${{
                                  property_details_inner_report.booking_earnings.toFixed(
                                    2
                                  )
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row pt-3 d-none">
                            <div class="col-4">
                              <p class="txt--xs opacity--50">
                                {{ $t("Early_Bird") }}
                              </p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs opacity--50">$17,845.20</p>
                            </div>
                          </div>
                          <div class="row pt-3 d-none">
                            <div class="col-4">
                              <p class="txt--xs opacity--50">
                                {{ $t("Special_Event") }}
                              </p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs opacity--50">$8,953.50</p>
                            </div>
                          </div>
                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--xs opacity--50">{{ $t("MC") }}</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs opacity--50">
                                ${{
                                  property_details_inner_report.permit_earnings.toFixed(
                                    2
                                  )
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="row pt-3">
                            <div class="col-4">
                              <p class="txt--xs opacity--50">{{ $t("AC") }}</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs opacity--50">
                                ${{
                                  property_details_inner_report.anonymous_earnings.toFixed(
                                    2
                                  )
                                }}
                              </p>
                            </div>
                          </div>

                          <!-- <div class="row pt-3 d-none">
                            <div class="col-4">
                              <p class="txt--xs opacity--50">{{ $t("AC") }}</p>
                            </div>
                            <div class="col-2">
                              <p class="txt--xs opacity--50">
                                ${{
                                  property_details_inner_report.anonymous_customer.toFixed(
                                    2
                                  )
                                }}
                              </p>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <div
                        class="content__divider"
                        :class="{ 'd-none': selected_property_name }"
                      ></div>
                    </div>
                    <!-- END EARNINGS -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mt-4">
            <div class="graph__area">
              
              <!-- SESSION & EARNING REPORT -->
              <div class="content__box content__box--graph h-50">
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li
                        :class="[earning == 1 ? 'active' : '']"
                        @click="changeSessionEarningReport(1,1)"
                      >
                        Sessions
                      </li>
                      <li
                        :class="[earning == 2 ? 'active' : '']"
                        @click="changeSessionEarningReport(2,1)"
                      >
                        Earnings
                      </li>
                    </ul>
                    
                    <ul class="top__filter__ul">

                      <li :class="[earning_customer_type == 1 ? 'active' : '']"
                        @click="changeSessionEarningReport(earning,1)">
                        ALL                        
                      </li>
                      <li :class="[earning_customer_type == 2 ? 'active' : '']"
                        @click="changeSessionEarningReport(earning,2)">
                       Transient            
                      </li>
                      <li :class="[earning_customer_type == 3 ? 'active' : '', 'dropdown-container-activate']">
                            <span @click="changeSessionEarningReport(earning, 3)">Permit</span>
                            <div class="dropdown-container" v-if="earning === 1">
                              <p
                                @click="changeSessionEarningReport(earning, 3)"
                                :class="[earning_customer_type == 3 && earning_permit_type_filter === 1 ? 'active' : '']"
                              >ALL</p>
                              <p
                                @click="changeSessionEarningReport(earning, 3, 2)"
                                :class="[earning_permit_type_filter === 2 ? 'active' : '']"
                              >Flex</p>
                              <p
                                @click="changeSessionEarningReport(earning, 3, 3)"
                                :class="[earning_permit_type_filter === 3 ? 'active' : '']"
                              >Recurring</p>
                            </div>                     
                          </li>
                      <li :class="[earning_customer_type == 4 ? 'active' : '']"
                         @click="changeSessionEarningReport(earning,4)">
                        Anonymous                        
                      </li>

                      <li class="active"><i class="far fa-question-circle" v-tooltip="earning==1 ? helperTexts.session_chart : helperTexts.earning_chart"></i></li>
                    </ul>
                  </div>
                  <div v-if="session_loader == 0">
                    <h2 class="primaryHeader">
                      {{ earning == 2 ? "$" : "" }} {{ session_total }}
                    </h2>
                    <p
                      :class="[
                        'transient-customers-records txt--ss mt-3',
                        session_inc ? ' txt--green' : 'txt--red',
                      ]"
                    >
                      <span
                        :class="[
                          session_inc ? 'txt--green' : 'txt--red',
                          'rounded-circle',
                        ]"
                      ></span>
                      {{ session_inc_value }}%
                    </p>
                  </div>
                  <div v-else-if="session_loader == 2">
                    <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                    <button @click="changeSessionEarningReport(earning,earning_customer_type)" type="button" class="button button--primary button--sm mr-3 mt-2">
                      Reload
                    </button>
                  </div>
                </div>
                <div
                  class="content__box__body responsive__height pt-0"
                  v-if="session_loader == 0"
                >
                  <!-- Put chart here -->
                  <SessionChart v-if="earning==1" :data="session_chart"/>
                  <Chart :data="session_chart" :chart_type="earning" v-else/>
                </div>
                <div class="content__box__body responsive__height pt-0" v-if="session_loader == 1">
                  <div class="d-flex justify-content-center">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- OCCUPANCY REPORT -->
              <div class="content__box content__box--graph h-50 mt-4">
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li class="active cursor-default">{{ $t("OCCUP") }}</li>
                    </ul>
                    <ul class="top__filter__ul">

                       <li :class="[occupancy_customer_type == 1 ? 'active' : '']"
                        @click="getCurrentOccupancyChart(1)">
                        ALL                        
                      </li>
                      <li :class="[occupancy_customer_type == 2 ? 'active' : '']"
                        @click="getCurrentOccupancyChart(2)">
                       Transient            
                      </li>
                      <li :class="[occupancy_customer_type == 3 ? 'active' : '', 'dropdown-container-activate']">
                         <span @click="getCurrentOccupancyChart(3)">Permit</span>
                        <div class="dropdown-container">
                          <p
                            @click="getCurrentOccupancyChart(3)"
                            :class="[occupancy_customer_type == 3 && permit_type_filter === 1 ? 'active' : '']"
                          >ALL</p>
                          <p
                            @click="getCurrentOccupancyChart(3, 2)"
                            :class="[permit_type_filter === 2 ? 'active' : '']"
                          >Flex</p>
                          <p
                            @click="getCurrentOccupancyChart(3, 3)"
                            :class="[permit_type_filter === 3 ? 'active' : '']"
                          >Recurring</p>
                        </div>                     
                      </li>
                      <li :class="[occupancy_customer_type == 4 ? 'active' : '']"
                         @click="getCurrentOccupancyChart(4)">
                        Anonymous                        
                      </li>

                      <li class="active"><i class="far fa-question-circle" v-tooltip="helperTexts.occupancy_chart"></i></li>
                    </ul>
                  </div>
                  <div v-if="occupancy_loader == 0">
                    <h2 class="primaryHeader">{{ occupancy_total }}%</h2>
                    <p
                      :class="[
                        'transient-customers-records txt--ss mt-3',
                        occupancy_inc ? 'txt--green' : 'txt--red',
                      ]"
                    >
                      <span
                        :class="[
                          occupancy_inc ? 'txt--green' : 'txt--red',
                          'rounded-circle',
                        ]"
                      ></span>
                      {{ occupancy_inc_percentage }}%
                    </p>
                  </div>
                  <div v-else-if="occupancy_loader == 2">
                    <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                    <button  @click="getCurrentOccupancyChart(occupancy_customer_type)" type="button" class="button button--primary button--sm mr-3 mt-2">
                      Reload
                    </button>
                  </div>
                </div>
                <div
                  class="content__box__body responsive__height pt-0"
                  v-if="occupancy_loader == 0"
                >
                  <!-- Put chart here -->
                  <Occupancy :data="occupancy_chart" />
                </div>
                <div v-else-if="occupancy_loader == 1" class="content__box__body responsive__height pt-0">
                  <div class="d-flex justify-content-center">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ExportReports></ExportReports>
   <!--  modal -->
    <SessionDetails
      @session_delete="sessionAfterDelete"
    />
  </div>
</template>

<script>
import SessionDetails from "@/components/modals/sessionDetails";
import SessionChart from "@/components/sessionChart";
import Chart from "@/components/ChartDrill";
import Occupancy from "@/components/ChartOccupancy";
import commonservices from "../../services/CommonService";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import ExportReports from "@/components/modals/ExportReports";
import helperTexts from "@/assets/data/helperText";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { ModelListSelect, MultiListSelect } from "vue-search-select";
import Vue from 'vue';

const service = new commonservices();

export default {
  name: "Report",
  components: {
    SessionChart,
    Chart: Chart,
    Occupancy: Occupancy,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    ExportReports: ExportReports,
    SessionDetails: SessionDetails,
  },
  data() {
    return {
      helperTexts,
      selected_space_id: null,
      admin_access: localStorage.getItem('admin_access'),
      commercial_user_id: localStorage.getItem('commercial_user_id'),
      /**
       * Filters
       */
      showByDropdown: false,
      showPermitByDropdown: false,
      showTimezoneDropdown: false,
      maxDate: this.$moment().format("YYYY-MM-DD"),
      minDate: "2018-01-01",
      property_list: [],
      date: {
        start: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
        end: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
      },
      selected_property_name: null,
      selected_permit_name: null,
      selected_permit_id: null,
      searchProperty: "",
      searchPermit: "",
      rangeShortCut: [],
      range_err: false,
      selected_time_zone: '',
      permit_list: [],
      time_zone_list: [
        'UTC',
        this.$moment.tz.guess()
      ],
      time_zone_list_temp: [
        'UTC',
        this.$moment.tz.guess()
      ],
      /**
       * Property Details Report
       */
      property_details_loader: false,
      property_details_report: [],
      property_details_inner_loader: false,
      property_details_inner_report: [],
      over_view_report_type: null,
      pagination: {page:1, load_more: true},
      /**
       * Avg Session Duration, Avg Session Amount, Transient, Permit, And Anonymous Customer Count
       */
      transient_report_source: null,
      permit_customer_source:null,
      transient_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      permit_customer_loader:0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      avg_session_report_source: null,
      avg_session_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      anonymous_customer_source:null,
      anonymous_customer_loader:0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      avg_price_source:null,
      avg_session_price_loader:0, // 0 => hidden, 1 => show loading icon, 2 => show reload button

      session_reports: {
        anonymous_customer: 0,
        anonymous_customer_inc: true,
        anonymous_customer_inc_value: "+" + 0,
        monthly_customer: 0,
        monthly_customer_inc: true,
        monthly_customer_inc_value: "+" + 0,
        avg_session_duration: 0,
        avg_session_duration_inc: true,
        avg_session_duration_inc_value: "+" + 0,
        avg_session_price: 0,
        avg_session_price_inc: true,
        avg_session_price_inc_value: "+" + 0,
        transient_customer: 0,
        transient_customer_inc: true,
        transient_customer_inc_value: "+" + 0,
      },
      date_range_type: "week",
      /**
       * Session, Earning & Occupancy Chart
       */
      // session / earning chart
      earning: 1,
      session_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      session_chart_source: null,
      session_chart: [],
      session_total: 0,
      session_inc: true,
      session_inc_value: "+0.00",
      earning_chart_source: null,
      chart_type: "week",
      // Occupancy chart
      occupancy_chart_report_type: "week",
      occupancy_chart: [],
      occupancy_total: 0.0,
      occupancy_inc: true,
      occupancy_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      occupancy_chart_source: null,
      occupancy_inc_percentage: "+0.00",
      prop_id:'',
      index_no:0,
      order_by: 'DESC',
      field_name: 'book_start_date',
      show_session: false,
      show_validation: false,

      percentLoader: false,

      earning_customer_type:1, // 1->all,2->transient,3->permit,4->anonymous
      occupancy_customer_type:1, // 1->all,2->transient,3->permit,4->anonymous
      current_prop_id:null,
      selected_drop_prop_id:null,
      permit_type_filter:1,
      earning_permit_type_filter:1,
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        console.log(binding);
      },
    },
  },
  created() {
    this.helperTexts = helperTexts;
    /**
     * Check Operator Has Access Or Not
     */
    window.EventBus.$on("access_update", () => {
      let access = JSON.parse(localStorage.getItem("commercial_access_list"));
      // this.selected_space_id=access.property_access_list;
      // console.log(access);
      if (
        Object.keys(access).includes("report_access") &&
        access.report_access == false
      ) {
        this.$router.push("/dashboard");
      }
    });
    this.selected_time_zone = this.$moment.tz.guess();
    this.getAllProperty();
    //this.getAllReports();
    
  },
  methods: {
    /**
     * Filters
     */
    setOrderBy(field, order)
    {
      this.order_by     = order;
      this.field_name   = field;
      this.show_session = true;
      // this.permitReport(this.property_id, this.index);
      this.sessionReport(this.prop_id, this.index_no);
    },
    setValidationOrderBy(field, order)
    {
      this.order_by     = order;
      this.field_name   = field;
      this.show_validation = true;
      //alert(this.order_by);
      // this.permitReport(this.property_id, this.index);
      this.validationReport(this.prop_id, this.index_no);
    },
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    getPermits() {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          commercial: 1,
          page: 1,
          limit: 500,
          all: 1,
          property_id: this.selected_space_id ?? '',
          search: this.searchPermit ?? '',
        })
        .then((res) => {
          if (res.data.status) {
            this.permit_list = res.data.data.permit_list ? res.data.data.permit_list : [];
          } else {
            this.permit_list = [];
          }
          if (this.permit_list.length == 0) { this.button.disabled = true; }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeDropdown() {
      this.showByDropdown = false;
      this.showPermitByDropdown = false;
    },
    closeTimezoneDropdown() {
      this.showTimezoneDropdown = false
    },
    openSessionDetails(session_id,deleted_status) {
      if (session_id == "" || session_id == undefined || session_id == null||deleted_status==true) {
        return;
      }
      var url = window.hostname;
      let formData = {
        booking_id: session_id,
        mode: "show-booking",
        time_zone: this.$moment.tz.guess(new Date()),
        booking_for: "owner",
      };

      url += "/api/auth/booking";
      this.axios
        .post(url, formData)
        .then((res) => {
          if (res.data.status) {
            this.$modal.show("session-details", {
              data: res.data.data.booking_details,
              session_type:
                res.data.data.booking_details.booking_end_date != "" ? 2 : 1,
            });
          } else {
            return;
          }
        })
        .catch((err) => {
          return;
        });
     
    },
    sessionAfterDelete(event){
      //console.log("event>>>>>>>>>>"+event);
      //delete feature only for anonymous user's session
      var index = this.property_details_inner_report.map(function(o) { return o.booking_id; }).indexOf(event.session_id);
      if(index>-1){
        //this.$delete(this.property_details_inner_report, index);
        this.property_details_inner_report[index].delete_status=true;
        this.getOverviewReport(this.prop_id,this.index_no);

        //reloading other boxes like occupency,session,total report
        //this.getTransientReport();
        //this.getPermitCustomer();
        // this.getAvgSessionReport();
        // this.getAnonymousCustomer();
        // this.getAvgSessionPrice();

        this.changeSessionEarningReport(this.earning,this.earning_customer_type);
        this.getCurrentOccupancyChart(this.occupancy_customer_type);
      }
      
    },
    //manual session end
   /*  refreshAfterManualSessionEnd(event){
     
      //console.log("event>>>>>>>>>>"+JSON.stringify(event.response.price_breakdown));
      
      var index = this.property_details_inner_report.map(function(o) { return o.booking_id; }).indexOf(event.session.booking_id);
      if(index>-1){
        //this.$delete(this.property_details_inner_report, index);
        // this.property_details_inner_report[index].delete_status='YES';

        this.property_details_inner_report[index].booking_end_date =
          event.response.booking_end_date;
       // console.log('this.property_details_inner_report[index].end>>'+this.property_details_inner_report[index].booking_end_date);  
        if(event.session.booking_type =='transient'){
            this.property_details_inner_report[index].subtotal =
            event.response.price_breakdown.payable_amount;  
            //console.log('this.property_details_inner_report[index].subtotal>>'+this.property_details_inner_report[index].subtotal);   
        }
        else if(event.session.booking_type =='anonymous')
        { 
            this.property_details_inner_report[index].estimated_earning =
            event.response.price_breakdown.payable_amount;
            //console.log('this.property_details_inner_report[index].estimated_earning>>'+this.property_details_inner_report[index].estimated_earning);
        }
       
        

        this.property_details_inner_report[index].stay_duration = this.getDuration(
          this.property_details_inner_report[index].booking_start_date,
          this.property_details_inner_report[index].booking_end_date
        );

        this.getOverviewReport(this.prop_id,this.index_no);

        this.getAvgSessionReport();
        this.getAnonymousCustomer();
        this.getAvgSessionPrice();

        this.changeSessionEarningReport(1);
        this.getCurrentOccupancyChart();
      }
      
    }, */
    getDuration(start_time, end_time) {
      var start = this.$moment(start_time).format("YYYY-MM-DD HH:mm:ss");
      var end = this.$moment(end_time).format("YYYY-MM-DD HH:mm:ss");

      var duration = this.$moment(end).diff(start);
      duration = duration / 1000;
      var data = "";
      var days = parseInt(parseInt(duration) / (3600 * 24));
      days = parseInt(days);
      if (days > 0) {
        data += days + " days ";
      }

      /*** get the hours ***/
      var hours = (parseInt(duration) / 3600) % 24;
      hours = parseInt(hours);
      if (hours > 0) {
        data += hours + " hrs ";
      }

      /*** get the minutes ***/
      var minutes = (parseInt(duration) / 60) % 60;
      minutes = parseInt(minutes);
      if (minutes > 0) {
        data += minutes + " mins ";
      }

      /*** get the seconds ***/
      var seconds = parseInt(duration) % 60;
      seconds = parseInt(seconds);
      if (seconds > 0 && hours <= 0 && minutes <= 0) {
        data += seconds + " secs";
      }
      return data;
    },
    async getAllProperty() {
      this.property_details_loader = true;
      let property_response = await service.getAllProperty(this.searchProperty);
      if (property_response.status == 200) {
        if (property_response.data.status) {
          this.property_list = property_response.data.data.all_space;
          this.getAllReportsForSpace(this.property_list[0]?this.property_list[0]:'');

          this.prepareOverviewReports();
          
          this.getAllPropertyOverviewReport();
        } else {
          this.property_details_loader = false;
          this.property_list = [];
        }
      } else {
        this.property_details_loader = false;
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "timex-circle",
          className: "error-class",
        });
      }
    },
    clearPermitFilter() {
      this.searchPermit= null;
      this.selected_permit_name = null;
      this.selected_permit_id = null;
      this.property_details_report = [];
      this.getAllReports();
      this.prepareOverviewReports();
      this.getAllPropertyOverviewReport();
    },
    clearPropertyFilter() {
      this.searchProperty= null;
      this.selected_space_id = null;
      this.selected_property_name = null;
      this.selected_drop_prop_id = null;
      this.time_zone_list = [
        'UTC',
        this.$moment.tz.guess()
      ];
      this.selected_time_zone = this.$moment.tz.guess();
      this.property_details_report = [];
      this.getAllProperty();
      //this.prepareOverviewReports();
      //this.getAllPropertyOverviewReport();
      //this.getAllReports();
    },
    getAllReportsForSpace(space, permit) {
      if (!permit) {
        this.clearPermitFilter();
        this.selected_drop_prop_id = space.space_id;
        this.selected_space_id = space.space_id;
        let index = this.time_zone_list.indexOf(space.time_zone);

        this.time_zone_list_temp = [
            'UTC',
            this.$moment.tz.guess()
        ];
        let indexTemp = this.time_zone_list_temp.indexOf(space.time_zone);
        
        if(index==-1) {
          this.time_zone_list = [
            'UTC',
            this.$moment.tz.guess()
          ];
          this.time_zone_list.push(space.time_zone);
        }
        else if(indexTemp>-1) {
          this.time_zone_list = [
            'UTC',
            this.$moment.tz.guess()
          ];
        }

        this.selected_property_name =
          space.property_name != ""
            ? space.property_name
            : space.address.split(",")[0];

        this.getPermits();
      } else {
        this.selected_permit_name = permit.permit_name;
        this.selected_permit_id = permit.permit_id;
      }
      this.getAllReports();
      this.prepareOverviewReports();
      this.getAllPropertyOverviewReport();
    },
    validateRange() {
      this.$nextTick(() => {
        // check if the date range is for single day
        if (
          this.date.end != null &&
          this.date.start != null &&
          this.date.start == this.date.end
        ) {
          this.date_range_type = "hour";
          this.getAllReports();
          this.getAllPropertyOverviewReport();
          return false;
        }
        // check if the date range is for a week
        if (
          this.date.end != null &&
          this.date.start != null &&
          this.$moment(this.date.start, "YYYY-MM-DD")
            .add(6, "days")
            .format("YYYY-MM-DD") == this.date.end
        ) {
          this.date_range_type = "week";
          this.getAllReports();
          this.getAllPropertyOverviewReport();
          return false;
        }
        // check if the date range is for a month
        if (
          this.date.end != null &&
          this.date.start != null &&
          this.$moment(this.date.start).endOf("month").format("YYYY-MM-DD") ==
            this.date.end &&
          this.$moment(this.date.start).startOf("month").format("YYYY-MM-DD") ==
            this.date.start
        ) {
          this.date_range_type = "day";
          this.getAllReports();
          this.getAllPropertyOverviewReport();
          return false;
        }
        // check if the date range is for a year or multiple month
        if (
          this.date.end != null &&
          this.date.start != null &&
          this.$moment(this.date.start).startOf("month").format("YYYY-MM-DD") ==
            this.date.start &&
          this.$moment(this.date.end).endOf("month").format("YYYY-MM-DD") ==
            this.date.end
        ) {
          this.date_range_type = "month";
          this.getAllReports();
          this.getAllPropertyOverviewReport();
          return false;
        }
        //============ Custom Date Range Selection ===============//
        if (this.date.end != null && this.date.start != null) {
          this.date_range_type = "custom";
          this.getAllReports();
          this.getAllPropertyOverviewReport();
          return false;
        }
        if (this.date.end == null && this.date.start != null) {
          this.date_range_type = "";
          return false;
        }
      });
    },
    getPreDateStart() {
      if (this.date.start == null) {
        this.$toasted.show("Please select a range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.date_range_type == "hour") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.date.end;
      } else if (this.date_range_type == "week") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.end)
          .add(-6, "days")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "day") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.end)
          .startOf("month")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "month") {
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.end)
          .startOf("year")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "custom") {
        let start = this.$moment(this.date.start).format("YYYY-MM-DD");
        let end = this.$moment(this.date.end).format("YYYY-MM-DD");
        var timeDiff = Math.abs(
          new Date(end).getTime() - new Date(start).getTime()
        );
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
        this.date.end = this.$moment(this.date.start)
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.date.start = this.$moment(this.date.start)
          .add(-diffDays, "days")
          .format("YYYY-MM-DD");
      } else {
        this.$toasted.show("Please select a date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      this.getAllReports();
      this.getAllPropertyOverviewReport();
    },
    getNextDateStart() {
      if (this.date.end == null) {
        this.$toasted.show("Please select a range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.date_range_type == "hour") {
        if (
          this.date.start >= this.$moment().add(-1, "days").format("YYYY-MM-DD")
        ) {
          return false;
        }
        this.date.start = this.$moment(this.date.start)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.date.start;
      } else if (this.date_range_type == "week") {
        if (
          this.$moment(this.date.end).add(6, "days").format("YYYY-MM-DD") >
          this.$moment().format("YYYY-MM-DD")
        ) {
          return false;
        }
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .add(6, "days")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "day") {
        if (
          this.$moment(this.date.start).endOf("month").format("YYYY-MM-DD") >
          this.$moment().format("YYYY-MM-DD")
        ) {
          return false;
        }
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "month") {
        if (
          this.$moment(this.date.start).endOf("year").format("YYYY-MM-DD") >
          this.$moment().format("YYYY-MM-DD")
        ) {
          return false;
        }
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .endOf("year")
          .format("YYYY-MM-DD");
      } else if (this.date_range_type == "custom") {
        let start = this.$moment(this.date.start).format("YYYY-MM-DD");
        let end = this.$moment(this.date.end).format("YYYY-MM-DD");
        var timeDiff = Math.abs(
          new Date(end).getTime() - new Date(start).getTime()
        );
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (
          this.$moment(this.date.start)
            .add(diffDays + 1, "days")
            .format("YYYY-MM-DD") >= this.$moment().format("YYYY-MM-DD")
        ) {
          return false;
        }
        this.date.start = this.$moment(this.date.end)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.date.end = this.$moment(this.date.start)
          .add(diffDays, "days")
          .format("YYYY-MM-DD");
      } else {
        this.$toasted.show("Please select a date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      this.getAllReports();
      this.getAllPropertyOverviewReport();
    },
    setReportTimezone(time_zone) {
      if(this.selected_time_zone == time_zone) {
        return;
      }
      this.selected_time_zone = time_zone;
      this.getAllReports();
      this.getAllPropertyOverviewReport();
    },
    /**
     * Property Overview Report
     * Overview Report Property Specific
     * Session Report With Infinite Loader Property Specific
     * Transient Report Property Specific
     * Permit Report Property Specific
     * Anonymous Report Property Specific
     * Occupancy Report Property Specific
     * Earning Report Property Specific
     */
    prepareOverviewReports() {
      this.property_details_report = [];
      this.property_list.map((val,index)=> {
        if(this.selected_space_id !=null) {
          if(this.selected_space_id == val.space_id) {
            this.property_details_report.push({
              space_id: val.space_id,
              space_name: val.property_name,
              session_count: 0,
              transient_customer_count: 0,
              anonymous_customer_count: 0,
              permit_customer_count: 0,
              validation_count:0,
              earnings: 0,
              occupancy: 0,
              loading: true,
            });
          }
        }
        else {

          if(this.property_details_report.length<3)
          {
            this.property_details_report.push({
              space_id: val.space_id,
              space_name: val.property_name,
              session_count: 0,
              transient_customer_count: 0,
              anonymous_customer_count: 0,
              permit_customer_count: 0,
              validation_count:0,
              earnings: 0,
              occupancy: 0,
              loading: true,
            });
          }
          
        }
        
      });
    },
    getAllPropertyOverviewReport() {
      this.property_details_loader = true;
      this.property_details_inner_loader = false;
      this.over_view_report_type = null;
      this.property_details_inner_report = [];
      // this.selected_space_id = null;
      this.pagination = {page:1, load_more: true};

      this.property_details_report.map((val,index)=> {
        if(index<3)
        { 
          this.$set(this.property_details_report[index],'loading',true);
          this.getOverviewReport(val.space_id,index);
        }
       
      });
      this.property_details_loader= false;
    },
    getOverviewReport(property_id, index) {
      
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'full',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id,
      })
      .then(res=> {
        this.property_details_report[index].loading = false;
        if(res.data.status) {
          if(Object.keys(res.data.data).length>0) {
            this.$set(this.property_details_report,index, res.data.data);
            this.property_details_report[index].occupancy = this.property_details_report[index].occupancy >100 ? 100 : this.property_details_report[index].occupancy ;
          }        
        } else if (res.data.message.includes("temporarily")) {
          this.$toasted.show(res.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        }
      })
      .catch(err=> {
        // console.log(err);
      });
    },
    sessionReport(property_id,index) {
      // console.log(property_id);
      // console.log(index);
      this.property_details_inner_report = [];
      this.prop_id = property_id;
      this.index_no = index;
     
      if(this.over_view_report_type == 'sessions'+index && this.show_session == false) {
        this.over_view_report_type = null;
        this.property_details_inner_report = [];
        this.pagination = {page:1,load_more:true};
        this.selected_space_id = null;
        this.refreshAllChartsFromReportList();
        return;
      }
      
      this.over_view_report_type = 'sessions'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();

      this.property_details_inner_loader = true;
      this.pagination = {page:1, load_more: true};
      this.show_audits = false;
      this.show_deleted = false;

      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type:  'sessions',
        from:         this.date.start,
        to:           this.date.end,
        time_zone:    this.selected_time_zone,
        space_id:     property_id,
        page:         this.pagination.page,
        order_by:     this.order_by,
        field_name:   this.field_name,
        show_audits:  this.show_audits,
        show_deleted: this.show_deleted,
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        this.show_session = false;
        if(res.data.status) {
          this.property_details_inner_report = res.data.data.session_list;
          if(this.property_details_inner_report.length>0) {
            this.pagination = res.data.data.pagination;
          }
          else{
            this.pagination = {load_more:0};
          }
        }
        else {
          this.property_details_inner_report = [];
          this.pagination = {load_more: 0};
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
        this.pagination = {load_more:0};
      });
    },
    getSessionsPaginationWise($state) {

      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type:  'sessions',
        from:         this.date.start,
        to:           this.date.end,
        time_zone:    this.selected_time_zone,
        space_id:     this.selected_space_id,
        page:         this.pagination.page,
        order_by:     this.order_by,
        field_name:   this.field_name,
        show_audits:  this.show_audits,
        show_deleted: this.show_deleted,
      })
      .then(res=> {
        if(res.data.status) {
          let property_details_inner_report = res.data.data.session_list;
          
          if(property_details_inner_report.length>0) {
            property_details_inner_report.map(val=> {
              this.property_details_inner_report.push(val);
            });
            this.pagination = res.data.data.pagination;

            $state.loaded();
            if(this.pagination.load_more !=1) {
              $state.complete();
            }
          }
          else {
            $state.complete();
            this.pagination = {load_more:0};
          }
        }
        else {
          $state.complete();
          this.pagination = {load_more: 0};
        }
      })
      .catch(err=> {
        $state.error();
      })
    },
    getSessionType(data) {
      if(data.session_type == 'transient') {
        return "Transient";
      }
      else if(data.session_type == 'monthly') {
        return "Permit";
      }
      else if(data.session_type == 'anonymous') {
        return "Anonymous";
      }
      else {
        return "";
      }
    },
    transientReport(property_id,index) {
      if(this.over_view_report_type == 'transient'+index) {
        this.over_view_report_type = null;
        this.property_details_inner_report = [];
        this.selected_space_id = null;
        this.refreshAllChartsFromReportList();
        return;
      }

      this.over_view_report_type = 'transient'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();
      
      this.property_details_inner_loader = true;
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'transient',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        if(res.data.status) {
          if(res.data.data.length>0) {
            this.property_details_inner_report = res.data.data;
          }
          else{
            this.property_details_inner_report = [];
          }
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      })
    },
    permitReport(property_id,index) {
      this.property_id  = property_id;
      this.index        = index;

      if(this.over_view_report_type == 'permit'+index) {
        this.over_view_report_type = null;
        this.selected_space_id = null;
        this.property_details_inner_report = [];
        this.refreshAllChartsFromReportList();
        return;
      }
      
      this.over_view_report_type = 'permit'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();
      
      this.property_details_inner_loader = true;
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'permit',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        if(res.data.status) {
          if(res.data.data.length>0) {
            this.property_details_inner_report = res.data.data;
          }
          else{
            this.property_details_inner_report = [];
          }
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      });
    },
    anonymousReport(property_id,index) {
      if(this.over_view_report_type == 'anonymous'+index) {
        this.over_view_report_type = null;
        this.selected_space_id = null;
        this.property_details_inner_report = [];
        this.refreshAllChartsFromReportList();
        return;
      }
      
      this.over_view_report_type = 'anonymous'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();
      
      this.property_details_inner_loader = true;
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'anonymous',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        if(res.data.status) {
          if(res.data.data.length>0) {
            this.property_details_inner_report = res.data.data;
          }
          else{
            this.property_details_inner_report = [];
          }
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      });
    },
    getValidationReportPageWise($state) {

      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'validation',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: this.prop_id,
        field_name: 'created_at',
        order_by: this.order_by,
        page:this.pagination.page,
        limit:10,
        all:0, // 0=>limit work 1=> all data wil be fetched
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        this.show_validation  = false;

        if(res.data.status) {
      
          if(res.data.data.validation_list.length>0) {
           
            let property_details_inner_report_new = res.data.data.validation_list;

          
            if(property_details_inner_report_new.length>0) {
              property_details_inner_report_new.map(val=> {
                this.property_details_inner_report.push(val);
              });
              
              this.pagination = res.data.data.pagination;

              $state.loaded();
              if(this.pagination.load_more !=1) {
                $state.complete();
              }
            }
            else {
              $state.complete();
              this.property_details_inner_report = [];
              this.pagination = {load_more:0};
            }
          }
          else{
           
            $state.complete();
            this.pagination = {load_more:0};
            this.property_details_inner_report = [];
          }
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      });
    },
    validationReport(property_id,index) {
      if(this.over_view_report_type == 'validation'+index && this.show_validation == false) {
        this.over_view_report_type = null;
        this.selected_space_id = null;
        this.property_details_inner_report = [];
        this.refreshAllChartsFromReportList();
        return;
      }
      
      this.prop_id = property_id;
      this.over_view_report_type = 'validation'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();

      this.pagination = {page:1, load_more: true};

      this.property_details_inner_loader = true;
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'validation',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id,
        field_name: 'created_at',
        order_by: this.order_by,
        page:this.pagination.page,
        limit:10,
        all:0, // 0=>limit work 1=> all data wil be fetched
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        this.show_validation  = false;

        if(res.data.status) {
          this.property_details_inner_report = res.data.data.validation_list;
          if(this.property_details_inner_report.length>0) {
            this.pagination = res.data.data.pagination;
          }
          else{
            this.pagination = {load_more:0};
          }
        }
        else {
          this.property_details_inner_report = [];
          this.pagination = {load_more: 0};
        }

      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      });
    },
    occupancyReport(property_id, index) {
      if(this.over_view_report_type == 'occupancy'+index) {
        this.over_view_report_type = null;
        this.selected_space_id = null;
        this.property_details_inner_report = [];
        this.refreshAllChartsFromReportList();
        return;
      }
      
      this.over_view_report_type = 'occupancy'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();
      
      this.property_details_inner_loader = true;
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'occupancy',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        if(res.data.status) {
          if(res.data.data.length>0) {
            this.property_details_inner_report = res.data.data;
            this.property_details_inner_report.map(val=> {
              if(val.occupancy > 1) {
                val.occupancy = 1;
              }
            })
          }
          else{
            this.property_details_inner_report = [];
          }
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      });
    },
    earningReport(property_id, index) {
      if(this.over_view_report_type == 'earnings'+index) {
        this.over_view_report_type = null;
        this.selected_space_id = null;
        this.property_details_inner_report = [];

        this.refreshAllChartsFromReportList();
        return;
      }

      this.over_view_report_type = 'earnings'+index;
      this.selected_space_id = property_id;

      this.refreshAllChartsFromReportList();
      
      this.property_details_inner_loader = true;
      this.axios.post(window.hostname+'/api/auth/reports/all',{
        report_type: 'earnings',
        from: this.date.start,
        to: this.date.end,
        time_zone: this.selected_time_zone,
        space_id: property_id
      })
      .then(res=> {
        this.property_details_inner_loader = false;
        if(res.data.status) {
          if(Object.keys(res.data.data).length>0) {
            this.property_details_inner_report = res.data.data;
          }
          else{
            this.property_details_inner_report = [];
          }
        }
      })
      .catch(err=> {
        this.property_details_inner_loader = false;
        this.property_details_inner_report = [];
      });
    },
    formatDateWithTimezone(date) {
      if(date!='') {
       // return this.$moment(date).tz(this.selected_time_zone).format("YYYY-MM-DD hh:mm:ss A zz");
       return this.$moment(date).format("YYYY-MM-DD hh:mm:ss A zz");
      }
    },
    /**
     * Transient Customer Count
     * Anonymous Customer Count
     * Permit Customer Count
     * Avg Session Duration
     * Avg Session Price
     */
    getTransientReport() {
      if (this.transient_report_source) {
        this.transient_report_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.transient_report_source = CancelToken.source();
      this.transient_loader = 1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/transient-customers", {
            device_type: 1,
            commercial: 1,
            space_id: this.selected_space_id,
            from: this.date.start,
            to: this.date.end,
            report_type: this.date_range_type,
            time_zone: this.selected_time_zone,
            permit_id: this.selected_permit_id,
          }, {
            cancelToken: this.transient_report_source.token,
        })
        .then((res) => {
          if (res.data.status) {
          this.transient_loader = 0;
          let response =service.getCalculateData(res.data.data.current_transient_customer_count , res.data.data.past_transient_customer_count);
          this.session_reports.transient_customer = res.data.data.current_transient_customer_count;
          this.session_reports.transient_customer_inc_value =response.data_inc;
          this.session_reports.transient_customer_inc =response.data_inc_status;
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
            this.transient_loader = 1;
          } else {
            this.transient_loader = 2;
            if (err.response.status == 401) {
              return;
            }
            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },
    getPermitCustomer(){
      if (this.permit_customer_source) {
        this.permit_customer_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.permit_customer_source = CancelToken.source();

      this.permit_customer_loader =1;
      this.axios
        .post(
          window.hostname + "api/auth/reports/permit-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from:this.date.start,
            to: this.date.end,
            report_type: this.report_type,
            space_id: this.selected_space_id,
            time_zone: this.selected_time_zone,
            permit_id: this.selected_permit_id,
          },
          {
            cancelToken: this.permit_customer_source.token,
          }
        ).then((res)=>{
          this.permit_customer_loader = 0;
            if(!res.data.status){
              return;
            }
            let response =service.getCalculateData(res.data.data.current_permit_customer_count, res.data.data.past_permit_customer_count);
            this.session_reports.monthly_customer =res.data.data.current_permit_customer_count;
            this.session_reports.monthly_customer_inc_value=response.data_inc;
            this.session_reports.monthly_customer_inc =response.data_inc_status;
            // console.log(response);
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err);
            this.permit_customer_loader = 1;
          } else {
            console.log(err);
            this.permit_customer_loader = 2;
          }
        });
    },
    getAvgSessionReport() {
      // Avg session duration calculation
      if (this.avg_source) {
        this.avg_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.avg_source = CancelToken.source();

      this.avg_session_loader = 1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/avg-duration",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            space_id: this.selected_space_id,
            from:this.date.start,
            to: this.date.end,
            report_type: this.report_type,
            time_zone: this.selected_time_zone,
          },
          {
            cancelToken: this.avg_source.token,
          }
        )
        .then((res) => {
          this.avg_session_loader = 0;
          if(!res.data.status) {
            return;
          }
          let response = service.getCalculateData(res.data.data.avg_session_duration_seconds,res.data.data.avg_session_duration_seconds_past);
          // console.log(res.data.data);
          // console.log(response);
          this.session_reports.avg_session_duration=res.data.data.avg_session_duration;
          this.session_reports.avg_session_duration_inc_value = response.data_inc;
          this.session_reports.avg_session_duration_inc = response.data_inc_status;
          // console.log(this.session_reports.avg_session_price_inc); 
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err);
            this.avg_session_loader = 1;
          } else {
            this.avg_session_loader = 2;
            console.log(err);
          }
        });
    },
    getAnonymousCustomer(){
      if (this.anonymous_customer_source) {
        this.anonymous_customer_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.anonymous_customer_source = CancelToken.source();
      this.anonymous_customer_loader = 1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/anonymous-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from:this.date.start,
            to: this.date.end,
            report_type: this.report_type,
            space_id: this.selected_space_id,
            time_zone: this.selected_time_zone,
            permit_id: this.selected_permit_id,
          },
          {
            cancelToken: this.anonymous_customer_source.token,
          }
        ).then((res)=>{
          this.anonymous_customer_loader = 0;
          if(!res.data.status){
            return;
          }
          let response =service.getCalculateData(res.data.data.current_anonymous_customer_count,res.data.data.past_anonymous_customer_count);
          // console.log(response);
          this.session_reports.anonymous_customer = res.data.data.current_anonymous_customer_count;
          this.session_reports.anonymous_customer_inc_value =response.data_inc;
          this.session_reports.anonymous_customer_inc =response.data_inc_status;

          // console.log(response);
        })      
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err);
            this.anonymous_customer_loader = 1;
          } else {
            // console.log(err);
            this.anonymous_customer_loader = 2;
          }
        });
    },
    getAvgSessionPrice(){
      if (this.avg_price_source) {
        this.avg_price_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.avg_price_source = CancelToken.source();
      this.avg_session_price_loader =1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/avg-price",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from:this.date.start,
            to: this.date.end,
            space_id: this.selected_space_id,
            report_type: this.report_type,
            time_zone: this.selected_time_zone,
          },
          {
            cancelToken: this.avg_price_source.token,
          }
        ).then((res)=>{
          this.avg_session_price_loader=0;
            if(!res.data.status) {
              return;
            }
          let response=service.getCalculateData(res.data.data.avg_session_price,res.data.data.avg_session_price_past);
          // console.log(response);
          this.session_reports.avg_session_price =res.data.data.avg_session_price.toFixed(2);
          this.session_reports.avg_session_price_inc_value =response.data_inc;
          this.session_reports.avg_session_price_inc = response.data_inc_status;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err);
            this.avg_session_price_loader = 1;
          } else {
            // console.log(err);
            this.avg_session_price_loader = 2;
          }
        });
    },
    refreshAllChartsFromReportList(){

      if( this.current_prop_id == this.selected_space_id || this.selected_drop_prop_id!=null){
        return;
      }
      this.changeSessionEarningReport(this.earning,this.earning_customer_type);
      this.getCurrentOccupancyChart(this.occupancy_customer_type);
    },
    /**
     * Session, Earning And Occupancy Chart
     */
    changeSessionEarningReport(type,cust_type, permit_type = 1) {
      this.earning_permit_type_filter = permit_type;
      if (this.date.start != null && this.date.end != null) {
        this.earning = type;
        this.earning_customer_type = cust_type;
        if(this.selected_drop_prop_id==null)
        {
            this.current_prop_id = this.selected_space_id?this.selected_space_id:null;
        }
        else{

            this.current_prop_id = this.selected_drop_prop_id;
            this.selected_space_id = this.selected_drop_prop_id;
        }
        
        this.session_loader = 1;
        if (this.earning == 1) {
          this.getSessionChartData(cust_type);
        } else {
          this.getEarningChartData(cust_type);
        }
      } else {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
      }
    },
    //================== API FOR SESSION CHART =========//
    getSessionChartData(cust_type) {
      let from = null;
      let to = null;
      if (this.chart_type == "hour") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "day") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "week") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "month") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "year") {
        from = "2018-01-01";
        to = this.date.end;
      } else if (this.chart_type == "custom") {
        from = this.date.start;
        to = this.date.end;
      } else {
        // this.$toasted.show("Something went wrong. Please try again!", {
        //   icon: "times-circle",
        //   className: "error-class",
        // });
        this.session_loader = 2;
        return false;
      }

      if (this.session_chart_source) {
        this.session_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_chart_source = CancelToken.source();
      this.axios
        .post(
          window.hostname + "api/auth/reports/sessions",
          {
            time_zone: this.selected_time_zone,
            from: from,
            to: to,
            commercial: 1,
            report_type: this.chart_type,
            space_id: this.selected_space_id,
            customer_type: cust_type,
            permit_type: this.earning_permit_type_filter,
            permit_id: this.selected_permit_id,
          },
          {
            cancelToken: this.session_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_total = parseInt(res.data.data.total);
            if (
              this.chart_type == "hour" ||
              this.chart_type == "week" ||
              this.chart_type == "day" ||
              this.chart_type == "custom"
            ) {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_inc_value = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_inc_value = "+100.00";
                } else {
                  this.session_inc_value = (
                    ((parseFloat(res.data.data.total) -
                      parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "+100.00"
                      : "+" + this.session_inc_value;
                }
              } else {
                this.session_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value = (
                    ((parseFloat(res.data.data.total_prev) -
                      parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "-100.00"
                      : "-" + this.session_inc_value;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseInt(this.session_chart[length].y);
              let prev_value = parseInt(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_inc_value = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_inc_value = "+0.00";
                } else {
                  this.session_inc_value = (
                    ((last_value - prev_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "+100.00"
                      : "+" + this.session_inc_value;
                }
              } else {
                this.session_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value = (
                    ((prev_value - last_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "-100.00"
                      : "-" + this.session_inc_value;
                }
              }
            }
            this.session_loader = 0;
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err.message);
            this.session_loader = 1;
          } else {
            this.session_loader = 2;
            if (err.response.status == 401) {
              return;
            }
            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },
    //================= API FOR EARNING CHART =============//
    async getEarningChartData(cust_type) {
      let from = null;
      let to = null;
      if (this.chart_type == "hour") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "day") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "week") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "month") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.chart_type == "year") {
        from = "2018-01-01";
        to = this.date.end;
      } else if (this.chart_type == "custom") {
        from = this.date.start;
        to = this.date.end;
      } else {
        // this.$toasted.show("Something went wrong. Please try again!", {
        //   icon: "times-circle",
        //   className: "error-class",
        // });
        this.session_loader = 2;
        return false;
      }

      if (this.session_chart_source) {
        this.session_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_chart_source = CancelToken.source();
      await this.axios
        .post(
          window.hostname + "api/auth/reports/earnings",
          {
            time_zone: this.selected_time_zone,
            from: from,
            to: to,
            commercial: 1,
            report_type: this.chart_type,
            space_id: this.selected_space_id,
            customer_type: cust_type,
            permit_type: this.earning_permit_type_filter,
            permit_id: this.selected_permit_id,
          },
          {
            cancelToken: this.session_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_total = parseFloat(res.data.data.total).toFixed(2);
            if (
              this.chart_type == "hour" ||
              this.chart_type == "week" ||
              this.chart_type == "day" ||
              this.chart_type == "custom"
            ) {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_inc_value = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_inc_value = "+100.00";
                } else {
                  this.session_inc_value = (
                    ((parseFloat(res.data.data.total) -
                      parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "+100.00"
                      : "+" + this.session_inc_value;
                }
              } else {
                this.session_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value = (
                    ((parseFloat(res.data.data.total_prev) -
                      parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "-100.00"
                      : "-" + this.session_inc_value;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseInt(this.session_chart[length].y);
              let prev_value = parseInt(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_inc_value = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_inc_value = "+0.00";
                } else {
                  this.session_inc_value = (
                    ((last_value - prev_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "+100.00"
                      : "+" + this.session_inc_value;
                }
              } else {
                this.session_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_inc_value = "-100.00";
                } else {
                  this.session_inc_value = (
                    ((prev_value - last_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_inc_value =
                    this.session_inc_value > 100
                      ? "-100.00"
                      : "-" + this.session_inc_value;
                }
              }
            }
            this.session_loader = 0;
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err.message);
            this.session_loader = 1;
          } else {
            this.session_loader = 2;
            if (err.response.status == 401) {
              return;
            }
            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },
    //=============== API FOR CURRENT OCCUPANCY CHART DATA ================//
    async getCurrentOccupancyChart(cust_type, permit_type = 1) {
      this.permit_type_filter = permit_type;

      let from = null;
      let to = null;
      if (this.occupancy_chart_report_type == "hour") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "day") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "week") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "month") {
        from = this.date.start;
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "year") {
        from = "2018-01-01";
        to = this.date.end;
      } else if (this.occupancy_chart_report_type == "custom") {
        from = this.date.start;
        to = this.date.end;
      } else {
        // this.$toasted.show("Something went wrong. Please try again!", {
        //   icon: "times-circle",
        //   className: "error-class",
        // });
        this.occupancy_loader = 2;
        return false;
      }

      this.occupancy_customer_type = cust_type;

      if(this.selected_drop_prop_id==null)
      {
          this.current_prop_id = this.selected_space_id?this.selected_space_id:null;
      }
      else{
          this.current_prop_id = this.selected_drop_prop_id;
          this.selected_space_id = this.selected_drop_prop_id;
      }
     

      if (this.occupancy_chart_source) {
        this.occupancy_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.occupancy_chart_source = CancelToken.source();

      //alert(this.occupancy_chart_report_type);

      await this.axios
        .post(
          window.hostname + "api/auth/reports/occupancy",
          {
            space_id: this.selected_space_id,
            report_type: this.occupancy_chart_report_type,
            from: from,
            to: to,
            commercial: 1,
            time_zone: this.selected_time_zone,
            customer_type: cust_type,
            permit_type: this.permit_type_filter,
            permit_id: this.selected_permit_id,
          },
          {
            cancelToken: this.occupancy_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.occupancy_chart = res.data.data.report_data;
            this.occupancy_total = parseFloat(res.data.data.total).toFixed(0);
            if (
              parseFloat(res.data.data.total) >
              parseFloat(res.data.data.total_prev)
            ) {
              this.occupancy_inc = true;
              let diff_data =
                parseFloat(res.data.data.total) -
                parseFloat(res.data.data.total_prev);
              let perc = (diff_data / parseFloat(res.data.data.total)) * 100;
              perc = perc.toFixed(2);
              perc = perc > 100 ? 100 : perc;
              this.occupancy_inc_percentage = "+" + perc;
            } else if (
              parseFloat(res.data.data.total) <
              parseFloat(res.data.data.total_prev)
            ) {
              this.occupancy_inc = false;
              let diff_data =
                parseFloat(res.data.data.total_prev) -
                parseFloat(res.data.data.total);
              let perc =
                (diff_data / parseFloat(res.data.data.total_prev)) * 100;
              perc = perc.toFixed(2);
              perc = perc > 100 ? 100 : perc;
              this.occupancy_inc_percentage = "-" + perc;
            } else {
              this.occupancy_inc = true;
              this.occupancy_inc_percentage = "+0.00";
            }
            this.occupancy_loader = 0;
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err.message);
            this.occupancy_loader = 1;
          } else {
            this.occupancy_loader = 2;
            if (err.response.status == 401) {
              return;
            }
            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },

    /**
     * Get All Reports Except For Property Overview Report
     */
    getAllReports() {
      if (this.date_range_type == "") {
        this.$toasted.show("Please select a date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      this.chart_type = this.date_range_type;
      this.occupancy_chart_report_type = this.date_range_type;
      this.transient_loader = 1;
      this.avg_session_loader = 1;
      this.session_loader = 1;
      this.occupancy_loader = 1;
      if (this.earning == 1) {
        //===================== Get Session Chart ==============//
        this.getSessionChartData(this.earning_customer_type);
      } else {
        //====================== Get Earning Chart =============//
        this.getEarningChartData(this.earning_customer_type);
      }
      //======================== Get Occupancy Chart ================//
      this.getCurrentOccupancyChart(this.occupancy_customer_type);
      //===================== Get Transient, Anonymous, Monthly customer, avg session duration, avg session price ====================//
      this.getTransientReport();
      this.getPermitCustomer();
      this.getAnonymousCustomer();
    //   this.getAvgSessionReport();
    //   this.getAvgSessionPrice();
    },
    /**
     * EXPORT SECTION
     * EXPORT IN XLSX FORMAT
     * EXPORT IN CSV FORMAT IN ZIP FILE
     */
    //=============== Get Page Data For PDF =========================//
    async getPageData() {
      if (this.date.start == null || this.date.end == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      //==== date range =====//
      let data = {};
      data.start_date = this.date.start;
      data.end_date = this.date.end;
      //==== report =====//
      data.quick_report = this.session_reports;
      data.occupancy_report = this.occupancy_chart;
      data.occupancy_total = this.occupancy_total;
      data.occupancy_inc = this.occupancy_inc;
      data.occupancy_inc_percentage = this.occupancy_inc_percentage;
      data.property_details_report = this.property_details_report;
      // console.log("1");
      //========== Earning report ==============//
      if (this.earning == 1) {
        let from = null;
        let to = null;
        if (this.chart_type == "hour") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "day") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "week") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "month") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "year") {
          from = "2018-01-01";
          to = this.date.end;
        } else if (this.chart_type == "custom") {
          from = this.date.start;
          to = this.date.end;
        } else {
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
        }

        await this.axios
          .post(window.hostname + "api/auth/earning-report", {
            time_zone: this.$moment.tz.guess(new Date()),
            from: from,
            to: to,
            commercial: 1,
            report_type: this.chart_type,
            space_id: this.selected_space_id,
          })
          .then((res) => {
            if (res.data.status) {
              data.earning_chart = res.data.data.report_data;
              data.earning_total = parseFloat(res.data.data.total).toFixed(2);
              if (
                this.chart_type == "hour" ||
                this.chart_type == "week" ||
                this.chart_type == "day" ||
                this.chart_type == "custom"
              ) {
                if (
                  parseFloat(res.data.data.total) >=
                  parseFloat(res.data.data.total_prev)
                ) {
                  data.earning_inc = true;
                  if (
                    parseFloat(res.data.data.total) ==
                    parseFloat(res.data.data.total_prev)
                  ) {
                    data.earning_inc_value = "+0.00";
                  } else if (
                    parseFloat(res.data.data.total) != 0 &&
                    parseFloat(res.data.data.total_prev) == 0
                  ) {
                    data.earning_inc_value = "+100.00";
                  } else {
                    data.earning_inc_value = (
                      ((parseFloat(res.data.data.total) -
                        parseFloat(res.data.data.total_prev)) /
                        parseFloat(res.data.data.total_prev)) *
                      100
                    ).toFixed(2);
                    data.earning_inc_value =
                      data.earning_inc_value > 100
                        ? "+100.00"
                        : "+" + data.earning_inc_value;
                  }
                } else {
                  data.earning_inc = false;
                  if (
                    parseFloat(res.data.data.total) == 0 &&
                    parseFloat(res.data.data.total_prev) != 0
                  ) {
                    data.earning_inc_value = "-100.00";
                  } else {
                    data.earning_inc_value = (
                      ((parseFloat(res.data.data.total_prev) -
                        parseFloat(res.data.data.total)) /
                        parseFloat(res.data.data.total_prev)) *
                      100
                    ).toFixed(2);
                    data.earning_inc_value =
                      data.earning_inc_value > 100
                        ? "-100.00"
                        : "-" + data.earning_inc_value;
                  }
                }
              } else {
                let length = data.earning_chart.length - 1;
                let last_value = parseFloat(
                  data.earning_chart[length].y
                ).toFixed(2);
                let prev_value = parseFloat(res.data.data.total_prev).toFixed(
                  2
                );
                if (last_value >= prev_value) {
                  data.earning_inc_value = true;
                  if (prev_value == 0 && last_value != 0) {
                    data.earning_inc_value = "+100.00";
                  } else if (prev_value == last_value) {
                    data.earning_inc_value = "+0.00";
                  } else {
                    data.earning_inc_value = (
                      ((last_value - prev_value) / prev_value) *
                      100
                    ).toFixed(2);
                    data.earning_inc_value =
                      data.earning_inc_value > 100
                        ? "+100.00"
                        : "+" + data.earning_inc_value;
                  }
                } else {
                  data.earning_inc = false;
                  if (prev_value != 0 && last_value == 0) {
                    data.earning_inc_value = "-100.00";
                  } else {
                    data.earning_inc_value = (
                      ((prev_value - last_value) / prev_value) *
                      100
                    ).toFixed(2);
                    data.earning_inc_value =
                      data.earning_inc_value > 100
                        ? "-100.00"
                        : "-" + data.earning_inc_value;
                  }
                }
              }
              console.log("2:1");
              localStorage.setItem("print_data", JSON.stringify(data));
              console.log(JSON.parse(localStorage.getItem("print_data")));
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.status == 401) {
              return;
            }
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          });
      } else {
        data.earning_chart = this.session_chart;
        data.earning_total = this.session_total;
        data.earning_inc = this.session_inc;
        data.earning_inc_value = this.session_inc_value;
        console.log("2:2");
      }
      // ======= Session report ==============//
      if (this.earning == 2) {
        let from = null;
        let to = null;
        if (this.chart_type == "hour") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "day") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "week") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "month") {
          from = this.date.start;
          to = this.date.end;
        } else if (this.chart_type == "year") {
          from = "2018-01-01";
          to = this.date.end;
        } else if (this.chart_type == "custom") {
          from = this.date.start;
          to = this.date.end;
        } else {
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
        }

        await this.axios
          .post(window.hostname + "api/auth/session-report", {
            time_zone: this.$moment.tz.guess(new Date()),
            from: from,
            to: to,
            commercial: 1,
            report_type: this.chart_type,
            space_id: this.selected_space_id,
          })
          .then((res) => {
            if (res.data.status) {
              data.session_chart = res.data.data.report_data;
              data.session_total = parseInt(res.data.data.total);
              if (
                this.chart_type == "hour" ||
                this.chart_type == "week" ||
                this.chart_type == "day" ||
                this.chart_type == "custom"
              ) {
                if (
                  parseFloat(res.data.data.total) >=
                  parseFloat(res.data.data.total_prev)
                ) {
                  data.session_inc = true;
                  if (
                    parseFloat(res.data.data.total) ==
                    parseFloat(res.data.data.total_prev)
                  ) {
                    data.session_inc_value = "+0.00";
                  } else if (
                    parseFloat(res.data.data.total) != 0 &&
                    parseFloat(res.data.data.total_prev) == 0
                  ) {
                    data.session_inc_value = "+100.00";
                  } else {
                    data.session_inc_value = (
                      ((parseFloat(res.data.data.total) -
                        parseFloat(res.data.data.total_prev)) /
                        parseFloat(res.data.data.total_prev)) *
                      100
                    ).toFixed(2);
                    data.session_inc_value =
                      data.session_inc_value > 100
                        ? "+100.00"
                        : "+" + data.session_inc_value;
                  }
                } else {
                  data.session_inc = false;
                  if (
                    parseFloat(res.data.data.total) == 0 &&
                    parseFloat(res.data.data.total_prev) != 0
                  ) {
                    data.session_inc_value = "-100.00";
                  } else {
                    data.session_inc_value = (
                      ((parseFloat(res.data.data.total_prev) -
                        parseFloat(res.data.data.total)) /
                        parseFloat(res.data.data.total_prev)) *
                      100
                    ).toFixed(2);
                    data.session_inc_value =
                      data.session_inc_value > 100
                        ? "-100.00"
                        : "-" + data.session_inc_value;
                  }
                }
              } else {
                let length = data.session_chart.length - 1;
                let last_value = parseInt(data.session_chart[length].y);
                let prev_value = parseInt(res.data.data.total_prev);
                if (last_value >= prev_value) {
                  data.session_inc = true;
                  if (prev_value == 0 && last_value != 0) {
                    data.session_inc_value = "+100.00";
                  } else if (prev_value == last_value) {
                    data.session_inc_value = "+0.00";
                  } else {
                    data.session_inc_value = (
                      ((last_value - prev_value) / prev_value) *
                      100
                    ).toFixed(2);
                    data.session_inc_value =
                      data.session_inc_value > 100
                        ? "+100.00"
                        : "+" + data.session_inc_value;
                  }
                } else {
                  data.session_inc = false;
                  if (prev_value != 0 && last_value == 0) {
                    data.session_inc_value = "-100.00";
                  } else {
                    data.session_inc_value = (
                      ((prev_value - last_value) / prev_value) *
                      100
                    ).toFixed(2);
                    data.session_inc_value =
                      data.session_inc_value > 100
                        ? "-100.00"
                        : "-" + data.session_inc_value;
                  }
                }
              }
              console.log("3:1");
              localStorage.setItem("print_data", JSON.stringify(data));
              console.log(JSON.parse(localStorage.getItem("print_data")));
            } else {
              this.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class",
              });
            }
          });
      } else {
        data.session_chart = this.session_chart;
        data.session_total = this.session_total;
        data.session_inc = this.session_inc;
        data.session_inc_value = this.session_inc_value;
        console.log("3:2");
        localStorage.setItem("print_data", JSON.stringify(data));
        console.log(JSON.parse(localStorage.getItem("print_data")));
      }

      this.$nextTick(() => {
        // this.$router.push({ name: "reportPdf" });
        let routeData = this.$router.resolve({ name: "reportPdf" });
        window.open(routeData.href, "_blank");
      });
    },
    //================ GET CSV ======================//
    getCSVOld() {
      if (this.date.start == null || this.date.end == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      // this.$toasted.show("Your file will be downloaded soon!", {
      //   icon: "check-circle",
      //   className: "success-class",
      // });
      this.$Progress.start();
      this.percentLoader = true;
      this.axios
        .post(window.hostname + "api/auth/export-csv", {
          from: this.date.start,
          to: this.date.end,
          time_zone: this.$moment.tz.guess(),
          device_type: 1,
          space_id: this.selected_space_id,
        })
        .then((res) => {
          if (res.data.status) {
            let csv_donload_link = res.data.data.file_path;
            // let file_name = res.data.data.file_name ;
            var element = document.createElement("a");
            element.href = csv_donload_link;
            element.setAttribute("download", "Reports.csv");

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
            this.$toasted.show("Your file download has started!", {
              icon: "check-circle",
              className: "success-class",
            });
            this.$Progress.finish();
            this.percentLoader = false;
          } else {
            this.$Progress.fail();
            this.percentLoader = false;
            this.$toasted.show(
              "File download failed. Please try again later!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
          }
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.$Progress.fail();
          this.percentLoader = false;
          this.$toasted.show("File download failed. Please try again later!", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    async getCSV() {
      const { value: email } = await this.$swal({
        title: "Enter Email To Send Exported Zip File",
        input: "text",
        inputValue: "",
        inputPlaceholder: "Enter email",
        showCancelButton: true,
        cancelButtonText: 'Skip',
        allowOutsideClick: false,
        allowEscapeKey: false,

      });
      if (this.date.start == null || this.date.end == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      let role =localStorage.getItem('role');
      let property_list =[];
      if(role =="operator"){
        let access =localStorage.getItem('commercial_access_list');
        this.property_details_report.map((val,index)=> {
          this.$set(this.property_details_report[index],'loading',true);
          property_list.push(val.space_id);  
        });
      }

      this.$Progress.start();
      this.percentLoader = true;
      this.axios
        .post(window.hostname + "api/auth/reports/export-zip", {
          from: this.date.start,
          to: this.date.end,
          time_zone: this.selected_time_zone,
          device_type: 1,
          space_id:this.selected_space_id,
          property_list: property_list,
          email: email,
          show_audits: this.show_audits,
          show_deleted: this.show_deleted,
        })
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.$Progress.finish();
            this.percentLoader = false;
          } else {
            this.$Progress.fail();
            this.percentLoader = false;
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          this.$Progress.fail();
          this.percentLoader = false;
          this.$toasted.show("File download failed. Please try again later!", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    async exportCustomReport(reportName, { requireDate = false, requireDateRangeType = false, requirePermitIds = false } = {}) {
        if (requireDate || requirePermitIds) {
            const currentDate = new Date(); 
            currentDate.setDate(currentDate.getDate() - 1);

            let selectedItem;
            let selectedPermits = [];
            let permitList = [];
            
            // If permit IDs are required, fetch the initial permit list
            if (requirePermitIds) {
                await this.axios.post(window.hostname + "/api/auth/permit/list", {
                    commercial: 1,
                    page: 1,
                    limit: 1000, // Increase limit to get more permits at once
                    all: 1,
                })
                .then((res) => {
                    if (res.data.status) {
                        permitList = res.data.data.permit_list ? res.data.data.permit_list : [];
                    }
                })
                .catch((err) => {
                    console.log(err);
                    permitList = [];
                });
            }

            let htmlContent = '';
            
            // Add date picker if required
            if (requireDate) {
                htmlContent += `
                    <p class="swal2-title title-class">Enter date for report</p>
                    <div id="select_date_range_type">
                        <input type="text" class="swal2-input input-class" id="report_date" value="${currentDate.toISOString().split('T')[0]}" placeholder="YYYY-MM-DD" />
                    </div>
                `;
            }
            
            // Add permit selector if required
            if (requirePermitIds) {
                htmlContent += `
                    <p class="swal2-title title-class" style="margin-top: ${requireDate ? '20px' : '0'}">Select permit(s)</p>
                    <p style="font-size: 14px; color: #666; margin-bottom: 10px;">Choose one or more permits to include in the report. The dropdown has built-in search functionality.</p>
                    <div id="permit_selector_container"></div>
                `;
            }

            const result = await this.$swal({
              html: htmlContent,
              showCancelButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: requirePermitIds ? '700px' : '600px',
              onOpen: () => {
                  // Handle date range type dropdown if required
                  if (requireDateRangeType) {
                      Vue.component('model-list-select', ModelListSelect);
                      const SwalDropdown = new Vue({
                      data: function() {
                          return {
                              selectedItem: 'month'
                          };
                      },
                      methods: {
                      },
                      render: function (createElement) {
                          return createElement('div',
                          {
                            style: {
                              display: "flex",
                              width: "100%",
                              justifyContent: "center",
                              marginTop: "10px"
                            }
                          },
                          [
                            createElement('model-list-select', {
                              ref: 'listSelect',
                              attrs: {
                                value: this.selectedItem,
                                list: [
                                  {
                                    type: 'month',
                                    name: 'Month'
                                  },
                                  {
                                    type: 'week',
                                    name: 'Week'
                                  },
                                  {
                                    type: 'day',
                                    name: 'Day'
                                  }
                                ],
                                'option-value': 'type',
                                'option-text': 'name',
                              },
                              on: {
                                input: value => this.selectedItem = value
                              },
                              class: ["custom-vue-select"],
                              placeholder: "Select range type",
                              style: {
                                width: "20em",
                                height: "32px",
                                borderRadius: "4px"
                              }
                            }),
                          ])
                      }
                  }).$mount();

                  if (requireDate) {
                      document.getElementById('select_date_range_type').prepend(SwalDropdown.$el);
                  }
                  selectedItem = SwalDropdown;
                  }
                  
                  // Handle permit selector if required
                  if (requirePermitIds) {
                      Vue.component('multi-list-select', MultiListSelect);
                      const PermitSelector = new Vue({
                          data: function() {
                              return {
                                  permitList: permitList,
                                  selectedPermits: []
                              };
                          },
                          methods: {
                              handlePermitSelection(items) {
                                  this.selectedPermits = items;
                                  selectedPermits = items;
                              },
                              selectAll() {
                                  this.selectedPermits = [...this.permitList];
                                  selectedPermits = this.selectedPermits;
                              },
                              clearAll() {
                                  this.selectedPermits = [];
                                  selectedPermits = [];
                              }
                          },
                          render: function(createElement) {
                              return createElement('div', {
                                  style: {
                                      display: 'flex',
                                      flexDirection: 'column',
                                      width: '100%',
                                      padding: '10px'
                                  }
                              }, [
                                  // Action buttons
                                  createElement('div', {
                                      style: {
                                          display: 'flex',
                                          gap: '10px',
                                          marginBottom: '10px',
                                          justifyContent: 'center'
                                      }
                                  }, [
                                      createElement('button', {
                                          attrs: {
                                              type: 'button',
                                              class: 'swal2-confirm swal2-styled'
                                          },
                                          style: {
                                              fontSize: '12px',
                                              padding: '5px 15px',
                                              backgroundColor: '#3085d6'
                                          },
                                          on: {
                                              click: this.selectAll
                                          }
                                      }, 'Select All'),
                                      createElement('button', {
                                          attrs: {
                                              type: 'button',
                                              class: 'swal2-cancel swal2-styled'
                                          },
                                          style: {
                                              fontSize: '12px',
                                              padding: '5px 15px',
                                              backgroundColor: '#aaa'
                                          },
                                          on: {
                                              click: this.clearAll
                                          }
                                      }, 'Clear All')
                                  ]),
                                  // Multi-select component
                                  createElement('multi-list-select', {
                                      attrs: {
                                          list: this.permitList,
                                          'option-value': 'permit_id',
                                          'option-text': 'permit_name',
                                          'selected-items': this.selectedPermits,
                                          placeholder: 'Search and select permit(s)...'
                                      },
                                      on: {
                                          select: this.handlePermitSelection
                                      },
                                      class: ['custom-vue-select']
                                  })
                              ]);
                          }
                      }).$mount();
                      
                      document.getElementById('permit_selector_container').appendChild(PermitSelector.$el);
                  }
            },

          }).then((result) => {
            if (result.isDismissed) {
              return false;
            }

            let data = {};
            
            if (requireDate) {
                const dateInput = document.getElementById('report_date').value;
                data.date = dateInput;
                
                if (selectedItem && requireDateRangeType) {
                  const selectedItemValue = selectedItem.selectedItem;
                  data['date_range_type'] = selectedItemValue;
                }
            }
            
            if (requirePermitIds && selectedPermits.length > 0) {
                data.permit_ids = selectedPermits.map(p => p.permit_id).join(',');
            } else if (requirePermitIds && selectedPermits.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'No permits selected',
                    text: 'Please select at least one permit to generate the report.',
                    confirmButtonText: 'OK'
                });
                return false;
            }

            if (result.isConfirmed) {
              return this.__exportCustomReport(reportName, data);
            }
          });
          return;
        }
        
        return this.__exportCustomReport(reportName, {});
    },
    async __exportCustomReport(reportName, reportOptions = {}) {
      const result = await this.$swal({
        title: "Enter Email To Send Exported Zip File",
        input: "text",
        inputValue: "",
        inputPlaceholder: "Enter email",
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonText: 'Skip',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (result.isConfirmed || result.dismiss === 'cancel') {
        this.$Progress.start();
        this.percentLoader = true;
        this.axios
          .post(window.hostname + "api/auth/reports/export-custom-zip", {
            device_type: 1,
            email: result.value,
            report_type: reportName,
            user_id: this.commercial_user_id,
            ...reportOptions
          })
          .then((res) => {
            if (res.data.status) {
              this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              this.$Progress.finish();
              this.percentLoader = false;
            } else {
              this.$Progress.fail();
              this.percentLoader = false;
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            console.log(err.response.data.message);
            this.$Progress.fail();
            this.percentLoader = false;
            this.$toasted.show("File download failed. Please try again later!", {
              icon: "times-circle",
              className: "error-class",
            });
          });
      }
    },
    getZip() {
      if (this.date.start == null || this.date.end == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      this.$toasted.show("Your file will be downloaded soon!", {
        icon: "check-circle",
        className: "success-class",
      });
      this.percentLoader = true;
      this.$Progress.start();
      this.axios
        .post(window.hostname + "api/auth/export-zip", {
          from: this.date.start,
          to: this.date.end,
          time_zone: this.selected_time_zone,
          device_type: 1,
          space_id: this.selected_space_id,
        })
        .then((res) => {
          if (res.data.status) {
            let zip_donload_link = res.data.data.file_path;
            // let file_name = res.data.data.file_name ;
            var element = document.createElement("a");
            element.href = zip_donload_link;
            element.setAttribute("download", "Reports.csv");

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
            this.$toasted.show("Your file download has started!", {
              icon: "check-circle",
              className: "success-class",
            });
            this.$Progress.finish();
            this.percentLoader = false;
          } else {
            this.$toasted.show(
              "File download failed. Please try again later!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
            this.$Progress.fail();
            this.percentLoader = false;
          }
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.$toasted.show("File download failed. Please try again later!", {
            icon: "times-circle",
            className: "error-class",
          });
          this.$Progress.fail();
          this.percentLoader = false;
        });
    },
  },
};
</script>

<style></style>